export var AclAction;
(function (AclAction) {
    AclAction["Delete"] = "DELETE";
    AclAction["Read"] = "READ";
    AclAction["Traverse"] = "TRAVERSE";
    AclAction["Write"] = "WRITE";
})(AclAction || (AclAction = {}));
export var Action;
(function (Action) {
    Action["Create"] = "CREATE";
    Action["Delete"] = "DELETE";
    Action["Read"] = "READ";
    Action["Update"] = "UPDATE";
    Action["UpdatePermissions"] = "UPDATE_PERMISSIONS";
})(Action || (Action = {}));
export var ActivityActorType;
(function (ActivityActorType) {
    ActivityActorType["Signatory"] = "Signatory";
    ActivityActorType["System"] = "System";
    ActivityActorType["Unknown"] = "Unknown";
    ActivityActorType["User"] = "User";
})(ActivityActorType || (ActivityActorType = {}));
export var ActivityTargetType;
(function (ActivityTargetType) {
    ActivityTargetType["Document"] = "Document";
    ActivityTargetType["Dummy"] = "Dummy";
})(ActivityTargetType || (ActivityTargetType = {}));
export var ActivityType;
(function (ActivityType) {
    ActivityType["ApprovalRequestApproved"] = "ApprovalRequestApproved";
    ActivityType["ApprovalRequestApproverApproved"] = "ApprovalRequestApproverApproved";
    ActivityType["ApprovalRequestApproverRejected"] = "ApprovalRequestApproverRejected";
    ActivityType["ApprovalRequestCancelled"] = "ApprovalRequestCancelled";
    ActivityType["ApprovalRequestCreated"] = "ApprovalRequestCreated";
    ActivityType["ApprovalRequestRejected"] = "ApprovalRequestRejected";
    ActivityType["ApprovalRequirementChecked"] = "ApprovalRequirementChecked";
    ActivityType["SignRequestApproverApproved"] = "SignRequestApproverApproved";
    ActivityType["SignRequestApproverOpened"] = "SignRequestApproverOpened";
    ActivityType["SignRequestApproverRejected"] = "SignRequestApproverRejected";
    ActivityType["SignRequestCancelled"] = "SignRequestCancelled";
    ActivityType["SignRequestCreated"] = "SignRequestCreated";
    ActivityType["SignRequestExpired"] = "SignRequestExpired";
    ActivityType["SignRequestFailed"] = "SignRequestFailed";
    ActivityType["SignRequestRejected"] = "SignRequestRejected";
    ActivityType["SignRequestReminded"] = "SignRequestReminded";
    ActivityType["SignRequestSignatoryChanged"] = "SignRequestSignatoryChanged";
    ActivityType["SignRequestSignatoryOpened"] = "SignRequestSignatoryOpened";
    ActivityType["SignRequestSignatoryRejected"] = "SignRequestSignatoryRejected";
    ActivityType["SignRequestSignatoryRemoved"] = "SignRequestSignatoryRemoved";
    ActivityType["SignRequestSignatorySigned"] = "SignRequestSignatorySigned";
    ActivityType["SignRequestSigned"] = "SignRequestSigned";
})(ActivityType || (ActivityType = {}));
export var AddDocumentDefaultsRejectionReason;
(function (AddDocumentDefaultsRejectionReason) {
    AddDocumentDefaultsRejectionReason["ActiveSignRequest"] = "ACTIVE_SIGN_REQUEST";
    AddDocumentDefaultsRejectionReason["NotAuthorized"] = "NOT_AUTHORIZED";
    AddDocumentDefaultsRejectionReason["NotFound"] = "NOT_FOUND";
})(AddDocumentDefaultsRejectionReason || (AddDocumentDefaultsRejectionReason = {}));
export var AddEsigningCreditsRejectionReason;
(function (AddEsigningCreditsRejectionReason) {
    AddEsigningCreditsRejectionReason["NotAuthorized"] = "NOT_AUTHORIZED";
    AddEsigningCreditsRejectionReason["NotFound"] = "NOT_FOUND";
})(AddEsigningCreditsRejectionReason || (AddEsigningCreditsRejectionReason = {}));
export var AddEsigningRecipientRejectionReason;
(function (AddEsigningRecipientRejectionReason) {
    AddEsigningRecipientRejectionReason["ActiveSignRequest"] = "ACTIVE_SIGN_REQUEST";
    AddEsigningRecipientRejectionReason["CannotNormalizeNames"] = "CANNOT_NORMALIZE_NAMES";
    AddEsigningRecipientRejectionReason["NotAuthorized"] = "NOT_AUTHORIZED";
})(AddEsigningRecipientRejectionReason || (AddEsigningRecipientRejectionReason = {}));
export var ApprovalRequestApproverStatus;
(function (ApprovalRequestApproverStatus) {
    ApprovalRequestApproverStatus["Approved"] = "Approved";
    ApprovalRequestApproverStatus["Pending"] = "Pending";
    ApprovalRequestApproverStatus["Queued"] = "Queued";
    ApprovalRequestApproverStatus["Rejected"] = "Rejected";
})(ApprovalRequestApproverStatus || (ApprovalRequestApproverStatus = {}));
export var ApprovalRequestStatus;
(function (ApprovalRequestStatus) {
    ApprovalRequestStatus["Approved"] = "Approved";
    ApprovalRequestStatus["Cancelled"] = "Cancelled";
    ApprovalRequestStatus["Pending"] = "Pending";
    ApprovalRequestStatus["Rejected"] = "Rejected";
})(ApprovalRequestStatus || (ApprovalRequestStatus = {}));
export var ApprovalType;
(function (ApprovalType) {
    ApprovalType["All"] = "All";
    ApprovalType["OneOf"] = "OneOf";
})(ApprovalType || (ApprovalType = {}));
export var ApproverStatus;
(function (ApproverStatus) {
    ApproverStatus["Approved"] = "APPROVED";
    ApproverStatus["Draft"] = "DRAFT";
    ApproverStatus["Failed"] = "FAILED";
    ApproverStatus["Opened"] = "OPENED";
    ApproverStatus["Pending"] = "PENDING";
    ApproverStatus["Rejected"] = "REJECTED";
    ApproverStatus["Unknown"] = "UNKNOWN";
})(ApproverStatus || (ApproverStatus = {}));
export var AssistantChatKind;
(function (AssistantChatKind) {
    AssistantChatKind["ApprovalWorkflow"] = "APPROVAL_WORKFLOW";
    AssistantChatKind["Regular"] = "REGULAR";
    AssistantChatKind["SignatoryWorkflow"] = "SIGNATORY_WORKFLOW";
    AssistantChatKind["Tabular"] = "TABULAR";
})(AssistantChatKind || (AssistantChatKind = {}));
export var AuthLinkPurpose;
(function (AuthLinkPurpose) {
    /** `EXECUTION` features provide metadata necessary for operation execution. */
    AuthLinkPurpose["Execution"] = "EXECUTION";
    /** `SECURITY` features provide metadata necessary to securely resolve fields. */
    AuthLinkPurpose["Security"] = "SECURITY";
})(AuthLinkPurpose || (AuthLinkPurpose = {}));
export var AuthUserPermissionRoleEnum;
(function (AuthUserPermissionRoleEnum) {
    AuthUserPermissionRoleEnum["Member"] = "MEMBER";
    AuthUserPermissionRoleEnum["Owner"] = "OWNER";
})(AuthUserPermissionRoleEnum || (AuthUserPermissionRoleEnum = {}));
export var AuthenticatedVar;
(function (AuthenticatedVar) {
    AuthenticatedVar["Authenticated"] = "AUTHENTICATED";
    AuthenticatedVar["NotAuthenticated"] = "NOT_AUTHENTICATED";
    AuthenticatedVar["NoUser"] = "NO_USER";
})(AuthenticatedVar || (AuthenticatedVar = {}));
export var CancelSignRequestRejectionReason;
(function (CancelSignRequestRejectionReason) {
    CancelSignRequestRejectionReason["AlreadyCancelled"] = "ALREADY_CANCELLED";
    CancelSignRequestRejectionReason["AlreadyCancelling"] = "ALREADY_CANCELLING";
    CancelSignRequestRejectionReason["AlreadySigned"] = "ALREADY_SIGNED";
    CancelSignRequestRejectionReason["NotAuthorized"] = "NOT_AUTHORIZED";
    CancelSignRequestRejectionReason["NotConnectedToEsigningProvider"] = "NOT_CONNECTED_TO_ESIGNING_PROVIDER";
    CancelSignRequestRejectionReason["NotFound"] = "NOT_FOUND";
    CancelSignRequestRejectionReason["ProviderRequestFailed"] = "PROVIDER_REQUEST_FAILED";
})(CancelSignRequestRejectionReason || (CancelSignRequestRejectionReason = {}));
/** https://stripe.com/docs/api/cards/object#card_object-brand */
export var CardPaymentMethodBrand;
(function (CardPaymentMethodBrand) {
    CardPaymentMethodBrand["AmericanExpress"] = "AMERICAN_EXPRESS";
    CardPaymentMethodBrand["DinersClub"] = "DINERS_CLUB";
    CardPaymentMethodBrand["Discover"] = "DISCOVER";
    CardPaymentMethodBrand["Jcb"] = "JCB";
    CardPaymentMethodBrand["MasterCard"] = "MASTER_CARD";
    CardPaymentMethodBrand["UnionPay"] = "UNION_PAY";
    CardPaymentMethodBrand["Unknown"] = "UNKNOWN";
    CardPaymentMethodBrand["Visa"] = "VISA";
})(CardPaymentMethodBrand || (CardPaymentMethodBrand = {}));
export var CcsDocumentFlushReason;
(function (CcsDocumentFlushReason) {
    CcsDocumentFlushReason["Converted"] = "CONVERTED";
    CcsDocumentFlushReason["Deleted"] = "DELETED";
    CcsDocumentFlushReason["EditingWithTemplate"] = "EDITING_WITH_TEMPLATE";
    CcsDocumentFlushReason["Locked"] = "LOCKED";
    CcsDocumentFlushReason["NewBundleVersion"] = "NEW_BUNDLE_VERSION";
    CcsDocumentFlushReason["SigningStatusCancelled"] = "SIGNING_STATUS_CANCELLED";
    CcsDocumentFlushReason["SigningStatusPending"] = "SIGNING_STATUS_PENDING";
    CcsDocumentFlushReason["SigningStatusRejected"] = "SIGNING_STATUS_REJECTED";
    CcsDocumentFlushReason["Unlocked"] = "UNLOCKED";
    CcsDocumentFlushReason["UserForced"] = "USER_FORCED";
})(CcsDocumentFlushReason || (CcsDocumentFlushReason = {}));
export var ChatMessageRole;
(function (ChatMessageRole) {
    ChatMessageRole["Assistant"] = "ASSISTANT";
    ChatMessageRole["System"] = "SYSTEM";
    ChatMessageRole["User"] = "USER";
})(ChatMessageRole || (ChatMessageRole = {}));
export var ChatMessageStatus;
(function (ChatMessageStatus) {
    ChatMessageStatus["Failed"] = "FAILED";
    ChatMessageStatus["Pending"] = "PENDING";
    ChatMessageStatus["Resolved"] = "RESOLVED";
})(ChatMessageStatus || (ChatMessageStatus = {}));
export var ChatMessageType;
(function (ChatMessageType) {
    ChatMessageType["DocumentAsk"] = "DOCUMENT_ASK";
    ChatMessageType["DocumentAskWithQuotes"] = "DOCUMENT_ASK_WITH_QUOTES";
    ChatMessageType["DocumentCompare"] = "DOCUMENT_COMPARE";
    ChatMessageType["DocumentSuggest"] = "DOCUMENT_SUGGEST";
    ChatMessageType["DocumentSummarize"] = "DOCUMENT_SUMMARIZE";
    ChatMessageType["DocumentSummarizeWithQuotes"] = "DOCUMENT_SUMMARIZE_WITH_QUOTES";
    ChatMessageType["SelectionAsk"] = "SELECTION_ASK";
    ChatMessageType["SelectionAskWithQuotes"] = "SELECTION_ASK_WITH_QUOTES";
    ChatMessageType["SelectionExplain"] = "SELECTION_EXPLAIN";
    ChatMessageType["SelectionRewrite"] = "SELECTION_REWRITE";
    ChatMessageType["SelectionSuggest"] = "SELECTION_SUGGEST";
    ChatMessageType["SelectionSummarize"] = "SELECTION_SUMMARIZE";
    ChatMessageType["SelectionSummarizeWithQuotes"] = "SELECTION_SUMMARIZE_WITH_QUOTES";
    ChatMessageType["SelectionTranslate"] = "SELECTION_TRANSLATE";
    ChatMessageType["WorkflowApprovalCheck"] = "WORKFLOW_APPROVAL_CHECK";
    ChatMessageType["WorkflowSignatoriesSuggest"] = "WORKFLOW_SIGNATORIES_SUGGEST";
})(ChatMessageType || (ChatMessageType = {}));
export var ChatResolutionStatus;
(function (ChatResolutionStatus) {
    ChatResolutionStatus["ChatNotSupported"] = "CHAT_NOT_SUPPORTED";
    ChatResolutionStatus["ContentLengthExceeded"] = "CONTENT_LENGTH_EXCEEDED";
    ChatResolutionStatus["MissingContentOrUnsupportedFileFormat"] = "MISSING_CONTENT_OR_UNSUPPORTED_FILE_FORMAT";
    ChatResolutionStatus["Unknown"] = "UNKNOWN";
})(ChatResolutionStatus || (ChatResolutionStatus = {}));
/** unique or primary key constraints on table "pl.company_activity" */
export var CompanyActivityConstraint;
(function (CompanyActivityConstraint) {
    /** unique or primary key constraint on columns "id" */
    CompanyActivityConstraint["CompanyActivityPkey"] = "company_activity_pkey";
})(CompanyActivityConstraint || (CompanyActivityConstraint = {}));
/** select columns of table "pl.company_activity" */
export var CompanyActivitySelectColumn;
(function (CompanyActivitySelectColumn) {
    /** column name */
    CompanyActivitySelectColumn["CompanyId"] = "company_id";
    /** column name */
    CompanyActivitySelectColumn["CreatedAt"] = "created_at";
    /** column name */
    CompanyActivitySelectColumn["Id"] = "id";
    /** column name */
    CompanyActivitySelectColumn["UserId"] = "user_id";
})(CompanyActivitySelectColumn || (CompanyActivitySelectColumn = {}));
/** update columns of table "pl.company_activity" */
export var CompanyActivityUpdateColumn;
(function (CompanyActivityUpdateColumn) {
    /** column name */
    CompanyActivityUpdateColumn["CompanyId"] = "company_id";
    /** column name */
    CompanyActivityUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    CompanyActivityUpdateColumn["Id"] = "id";
    /** column name */
    CompanyActivityUpdateColumn["UserId"] = "user_id";
})(CompanyActivityUpdateColumn || (CompanyActivityUpdateColumn = {}));
export var CompanyAnnualRevenueRangeEnum2;
(function (CompanyAnnualRevenueRangeEnum2) {
    CompanyAnnualRevenueRangeEnum2["Large"] = "large";
    CompanyAnnualRevenueRangeEnum2["Medium"] = "medium";
    CompanyAnnualRevenueRangeEnum2["Small"] = "small";
    CompanyAnnualRevenueRangeEnum2["VeryLarge"] = "very_large";
})(CompanyAnnualRevenueRangeEnum2 || (CompanyAnnualRevenueRangeEnum2 = {}));
/** unique or primary key constraints on table "pl.company_annual_revenue_range_enum" */
export var CompanyAnnualRevenueRangeEnumConstraint;
(function (CompanyAnnualRevenueRangeEnumConstraint) {
    /** unique or primary key constraint on columns "name" */
    CompanyAnnualRevenueRangeEnumConstraint["CompanyAnnualRevenueRangeEnumPkey"] = "company_annual_revenue_range_enum_pkey";
})(CompanyAnnualRevenueRangeEnumConstraint || (CompanyAnnualRevenueRangeEnumConstraint = {}));
export var CompanyAnnualRevenueRangeEnumEnum;
(function (CompanyAnnualRevenueRangeEnumEnum) {
    /** between 1,000,000 and 5,000,000 euros */
    CompanyAnnualRevenueRangeEnumEnum["Large"] = "large";
    /** between 200,000 and 1,000,000 euros */
    CompanyAnnualRevenueRangeEnumEnum["Medium"] = "medium";
    /** between 0 and 200,000 euros */
    CompanyAnnualRevenueRangeEnumEnum["Small"] = "small";
    /** above 5,000,000 euros */
    CompanyAnnualRevenueRangeEnumEnum["VeryLarge"] = "very_large";
})(CompanyAnnualRevenueRangeEnumEnum || (CompanyAnnualRevenueRangeEnumEnum = {}));
/** select columns of table "pl.company_annual_revenue_range_enum" */
export var CompanyAnnualRevenueRangeEnumSelectColumn;
(function (CompanyAnnualRevenueRangeEnumSelectColumn) {
    /** column name */
    CompanyAnnualRevenueRangeEnumSelectColumn["Description"] = "description";
    /** column name */
    CompanyAnnualRevenueRangeEnumSelectColumn["Name"] = "name";
})(CompanyAnnualRevenueRangeEnumSelectColumn || (CompanyAnnualRevenueRangeEnumSelectColumn = {}));
/** update columns of table "pl.company_annual_revenue_range_enum" */
export var CompanyAnnualRevenueRangeEnumUpdateColumn;
(function (CompanyAnnualRevenueRangeEnumUpdateColumn) {
    /** column name */
    CompanyAnnualRevenueRangeEnumUpdateColumn["Description"] = "description";
    /** column name */
    CompanyAnnualRevenueRangeEnumUpdateColumn["Name"] = "name";
})(CompanyAnnualRevenueRangeEnumUpdateColumn || (CompanyAnnualRevenueRangeEnumUpdateColumn = {}));
export var CompanyBusinessTypeEnum2;
(function (CompanyBusinessTypeEnum2) {
    CompanyBusinessTypeEnum2["B2b"] = "b2b";
    CompanyBusinessTypeEnum2["B2bB2c"] = "b2b_b2c";
    CompanyBusinessTypeEnum2["B2c"] = "b2c";
})(CompanyBusinessTypeEnum2 || (CompanyBusinessTypeEnum2 = {}));
/** unique or primary key constraints on table "pl.company_business_type_enum" */
export var CompanyBusinessTypeEnumConstraint;
(function (CompanyBusinessTypeEnumConstraint) {
    /** unique or primary key constraint on columns "name" */
    CompanyBusinessTypeEnumConstraint["CompanyBusinessTypeEnumPkey"] = "company_business_type_enum_pkey";
})(CompanyBusinessTypeEnumConstraint || (CompanyBusinessTypeEnumConstraint = {}));
export var CompanyBusinessTypeEnumEnum;
(function (CompanyBusinessTypeEnumEnum) {
    /** Business to Business */
    CompanyBusinessTypeEnumEnum["B2b"] = "b2b";
    /** Business to Business & Business to Consumers */
    CompanyBusinessTypeEnumEnum["B2bB2c"] = "b2b_b2c";
    /** Business to Consumers */
    CompanyBusinessTypeEnumEnum["B2c"] = "b2c";
})(CompanyBusinessTypeEnumEnum || (CompanyBusinessTypeEnumEnum = {}));
/** select columns of table "pl.company_business_type_enum" */
export var CompanyBusinessTypeEnumSelectColumn;
(function (CompanyBusinessTypeEnumSelectColumn) {
    /** column name */
    CompanyBusinessTypeEnumSelectColumn["Description"] = "description";
    /** column name */
    CompanyBusinessTypeEnumSelectColumn["Name"] = "name";
})(CompanyBusinessTypeEnumSelectColumn || (CompanyBusinessTypeEnumSelectColumn = {}));
/** update columns of table "pl.company_business_type_enum" */
export var CompanyBusinessTypeEnumUpdateColumn;
(function (CompanyBusinessTypeEnumUpdateColumn) {
    /** column name */
    CompanyBusinessTypeEnumUpdateColumn["Description"] = "description";
    /** column name */
    CompanyBusinessTypeEnumUpdateColumn["Name"] = "name";
})(CompanyBusinessTypeEnumUpdateColumn || (CompanyBusinessTypeEnumUpdateColumn = {}));
/** unique or primary key constraints on table "pl.company" */
export var CompanyConstraint;
(function (CompanyConstraint) {
    /** unique or primary key constraint on columns "id", "stripe_customer_id" */
    CompanyConstraint["CompanyIdStripeCustomerIdKey"] = "company_id_stripe_customer_id_key";
    /** unique or primary key constraint on columns "id" */
    CompanyConstraint["CompanyPkey"] = "company_pkey";
    /** unique or primary key constraint on columns "stripe_customer_id" */
    CompanyConstraint["CompanyStripeCustomerIdKey"] = "company_stripe_customer_id_key";
})(CompanyConstraint || (CompanyConstraint = {}));
export var CompanyEmployeeCountEnum2;
(function (CompanyEmployeeCountEnum2) {
    CompanyEmployeeCountEnum2["Large"] = "large";
    CompanyEmployeeCountEnum2["Medium"] = "medium";
    CompanyEmployeeCountEnum2["Small"] = "small";
    CompanyEmployeeCountEnum2["Smalltiny"] = "smalltiny";
    CompanyEmployeeCountEnum2["Tiny"] = "tiny";
    CompanyEmployeeCountEnum2["Xlarge"] = "xlarge";
    CompanyEmployeeCountEnum2["Xxlarge"] = "xxlarge";
    CompanyEmployeeCountEnum2["Xxxlarge"] = "xxxlarge";
})(CompanyEmployeeCountEnum2 || (CompanyEmployeeCountEnum2 = {}));
/** unique or primary key constraints on table "pl.company_employee_count_enum" */
export var CompanyEmployeeCountEnumConstraint;
(function (CompanyEmployeeCountEnumConstraint) {
    /** unique or primary key constraint on columns "name" */
    CompanyEmployeeCountEnumConstraint["CompanyEmployeeCountEnumPkey"] = "company_employee_count_enum_pkey";
})(CompanyEmployeeCountEnumConstraint || (CompanyEmployeeCountEnumConstraint = {}));
export var CompanyEmployeeCountEnumEnum;
(function (CompanyEmployeeCountEnumEnum) {
    /** 501-1,000 employees */
    CompanyEmployeeCountEnumEnum["Large"] = "large";
    /** 251-500 employees */
    CompanyEmployeeCountEnumEnum["Medium"] = "medium";
    /** 51-250 employees */
    CompanyEmployeeCountEnumEnum["Small"] = "small";
    /** 11-50 employees */
    CompanyEmployeeCountEnumEnum["Smalltiny"] = "smalltiny";
    /** up to 10 employees */
    CompanyEmployeeCountEnumEnum["Tiny"] = "tiny";
    /** 1,001-5,000 employees */
    CompanyEmployeeCountEnumEnum["Xlarge"] = "xlarge";
    /** 5,001-10,000 employees */
    CompanyEmployeeCountEnumEnum["Xxlarge"] = "xxlarge";
    /** More than 10,000 employees */
    CompanyEmployeeCountEnumEnum["Xxxlarge"] = "xxxlarge";
})(CompanyEmployeeCountEnumEnum || (CompanyEmployeeCountEnumEnum = {}));
/** select columns of table "pl.company_employee_count_enum" */
export var CompanyEmployeeCountEnumSelectColumn;
(function (CompanyEmployeeCountEnumSelectColumn) {
    /** column name */
    CompanyEmployeeCountEnumSelectColumn["Description"] = "description";
    /** column name */
    CompanyEmployeeCountEnumSelectColumn["Name"] = "name";
})(CompanyEmployeeCountEnumSelectColumn || (CompanyEmployeeCountEnumSelectColumn = {}));
/** update columns of table "pl.company_employee_count_enum" */
export var CompanyEmployeeCountEnumUpdateColumn;
(function (CompanyEmployeeCountEnumUpdateColumn) {
    /** column name */
    CompanyEmployeeCountEnumUpdateColumn["Description"] = "description";
    /** column name */
    CompanyEmployeeCountEnumUpdateColumn["Name"] = "name";
})(CompanyEmployeeCountEnumUpdateColumn || (CompanyEmployeeCountEnumUpdateColumn = {}));
export var CompanyIndustryEnum2;
(function (CompanyIndustryEnum2) {
    CompanyIndustryEnum2["Other"] = "_other";
    CompanyIndustryEnum2["AnimalHealth"] = "animal_health";
    CompanyIndustryEnum2["BankingFinancialServices"] = "banking_financial_services";
    CompanyIndustryEnum2["ComputerGames"] = "computer_games";
    CompanyIndustryEnum2["ComputerSoftware"] = "computer_software";
    CompanyIndustryEnum2["Construction"] = "construction";
    CompanyIndustryEnum2["ConsultancyServices"] = "consultancy_services";
    CompanyIndustryEnum2["ConsumersGoods"] = "consumers_goods";
    CompanyIndustryEnum2["Ecommerce"] = "ecommerce";
    CompanyIndustryEnum2["Education"] = "education";
    CompanyIndustryEnum2["FoodBeverages"] = "food_beverages";
    CompanyIndustryEnum2["HealthCare"] = "health_care";
    CompanyIndustryEnum2["Hospitality"] = "hospitality";
    CompanyIndustryEnum2["Insurance"] = "insurance";
    CompanyIndustryEnum2["ItServices"] = "it_services";
    CompanyIndustryEnum2["LogisticsSupplyChain"] = "logistics_supply_chain";
    CompanyIndustryEnum2["MarketingAdvertising"] = "marketing_advertising";
    CompanyIndustryEnum2["MusicEntertainment"] = "music_entertainment";
    CompanyIndustryEnum2["RealEstate"] = "real_estate";
    CompanyIndustryEnum2["Retail"] = "retail";
    CompanyIndustryEnum2["Telecommunication"] = "telecommunication";
})(CompanyIndustryEnum2 || (CompanyIndustryEnum2 = {}));
/** unique or primary key constraints on table "pl.company_industry_enum" */
export var CompanyIndustryEnumConstraint;
(function (CompanyIndustryEnumConstraint) {
    /** unique or primary key constraint on columns "name" */
    CompanyIndustryEnumConstraint["CompanyIndustryEnumPkey"] = "company_industry_enum_pkey";
})(CompanyIndustryEnumConstraint || (CompanyIndustryEnumConstraint = {}));
export var CompanyIndustryEnumEnum;
(function (CompanyIndustryEnumEnum) {
    /** Other */
    CompanyIndustryEnumEnum["Other"] = "_other";
    /** Animal health */
    CompanyIndustryEnumEnum["AnimalHealth"] = "animal_health";
    /** Banking/Financial Services */
    CompanyIndustryEnumEnum["BankingFinancialServices"] = "banking_financial_services";
    /** Computer Games */
    CompanyIndustryEnumEnum["ComputerGames"] = "computer_games";
    /** Computer software */
    CompanyIndustryEnumEnum["ComputerSoftware"] = "computer_software";
    /** Construction */
    CompanyIndustryEnumEnum["Construction"] = "construction";
    /** Consultancy Services */
    CompanyIndustryEnumEnum["ConsultancyServices"] = "consultancy_services";
    /** Consumers goods */
    CompanyIndustryEnumEnum["ConsumersGoods"] = "consumers_goods";
    /** E-commerce */
    CompanyIndustryEnumEnum["Ecommerce"] = "ecommerce";
    /** Education */
    CompanyIndustryEnumEnum["Education"] = "education";
    /** Food & Beverages */
    CompanyIndustryEnumEnum["FoodBeverages"] = "food_beverages";
    /** Health Care */
    CompanyIndustryEnumEnum["HealthCare"] = "health_care";
    /** Hospitality */
    CompanyIndustryEnumEnum["Hospitality"] = "hospitality";
    /** Insurance */
    CompanyIndustryEnumEnum["Insurance"] = "insurance";
    /** Information Technology & Services */
    CompanyIndustryEnumEnum["ItServices"] = "it_services";
    /** Logistics & Supply Chain */
    CompanyIndustryEnumEnum["LogisticsSupplyChain"] = "logistics_supply_chain";
    /** Marketing & Advertising */
    CompanyIndustryEnumEnum["MarketingAdvertising"] = "marketing_advertising";
    /** Music & Entertainment */
    CompanyIndustryEnumEnum["MusicEntertainment"] = "music_entertainment";
    /** Real estate */
    CompanyIndustryEnumEnum["RealEstate"] = "real_estate";
    /** Retail */
    CompanyIndustryEnumEnum["Retail"] = "retail";
    /** Telecommunication */
    CompanyIndustryEnumEnum["Telecommunication"] = "telecommunication";
})(CompanyIndustryEnumEnum || (CompanyIndustryEnumEnum = {}));
/** select columns of table "pl.company_industry_enum" */
export var CompanyIndustryEnumSelectColumn;
(function (CompanyIndustryEnumSelectColumn) {
    /** column name */
    CompanyIndustryEnumSelectColumn["Description"] = "description";
    /** column name */
    CompanyIndustryEnumSelectColumn["Name"] = "name";
})(CompanyIndustryEnumSelectColumn || (CompanyIndustryEnumSelectColumn = {}));
/** update columns of table "pl.company_industry_enum" */
export var CompanyIndustryEnumUpdateColumn;
(function (CompanyIndustryEnumUpdateColumn) {
    /** column name */
    CompanyIndustryEnumUpdateColumn["Description"] = "description";
    /** column name */
    CompanyIndustryEnumUpdateColumn["Name"] = "name";
})(CompanyIndustryEnumUpdateColumn || (CompanyIndustryEnumUpdateColumn = {}));
/** unique or primary key constraints on table "pl.company_plan" */
export var CompanyPlanConstraint;
(function (CompanyPlanConstraint) {
    /** unique or primary key constraint on columns "company_id" */
    CompanyPlanConstraint["CompanyPlanCompanyIdKey"] = "company_plan_company_id_key";
    /** unique or primary key constraint on columns "id" */
    CompanyPlanConstraint["CompanyPlanPkey"] = "company_plan_pkey";
})(CompanyPlanConstraint || (CompanyPlanConstraint = {}));
/** select columns of table "pl.company_plan" */
export var CompanyPlanSelectColumn;
(function (CompanyPlanSelectColumn) {
    /** column name */
    CompanyPlanSelectColumn["CompanyId"] = "company_id";
    /** column name */
    CompanyPlanSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    CompanyPlanSelectColumn["Id"] = "id";
    /** column name */
    CompanyPlanSelectColumn["PlanId"] = "plan_id";
    /** column name */
    CompanyPlanSelectColumn["StripeSubscriptionId"] = "stripe_subscription_id";
    /** column name */
    CompanyPlanSelectColumn["UpdatedAt"] = "updated_at";
})(CompanyPlanSelectColumn || (CompanyPlanSelectColumn = {}));
/** update columns of table "pl.company_plan" */
export var CompanyPlanUpdateColumn;
(function (CompanyPlanUpdateColumn) {
    /** column name */
    CompanyPlanUpdateColumn["CompanyId"] = "company_id";
    /** column name */
    CompanyPlanUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    CompanyPlanUpdateColumn["Id"] = "id";
    /** column name */
    CompanyPlanUpdateColumn["PlanId"] = "plan_id";
    /** column name */
    CompanyPlanUpdateColumn["StripeSubscriptionId"] = "stripe_subscription_id";
    /** column name */
    CompanyPlanUpdateColumn["UpdatedAt"] = "updated_at";
})(CompanyPlanUpdateColumn || (CompanyPlanUpdateColumn = {}));
/** unique or primary key constraints on table "pl.company_preferred_usage" */
export var CompanyPreferredUsageConstraint;
(function (CompanyPreferredUsageConstraint) {
    /** unique or primary key constraint on columns "id" */
    CompanyPreferredUsageConstraint["CompanyPreferredUsagePkey"] = "company_preferred_usage_pkey";
})(CompanyPreferredUsageConstraint || (CompanyPreferredUsageConstraint = {}));
export var CompanyPreferredUsageEnum2;
(function (CompanyPreferredUsageEnum2) {
    CompanyPreferredUsageEnum2["Other"] = "_other";
    CompanyPreferredUsageEnum2["AllOfTheAbove"] = "all_of_the_above";
    CompanyPreferredUsageEnum2["ESigning"] = "e_signing";
    CompanyPreferredUsageEnum2["NeedForAllInOnePlatform"] = "need_for_all_in_one_platform";
    CompanyPreferredUsageEnum2["NeedForContractAutomation"] = "need_for_contract_automation";
    CompanyPreferredUsageEnum2["NeedForContractManagement"] = "need_for_contract_management";
    CompanyPreferredUsageEnum2["NeedForESigning"] = "need_for_e_signing";
    CompanyPreferredUsageEnum2["NeedForOneAgreement"] = "need_for_one_agreement";
    CompanyPreferredUsageEnum2["NeedLegalTemplate"] = "need_legal_template";
    CompanyPreferredUsageEnum2["WorkSmarterWithLegal"] = "work_smarter_with_legal";
})(CompanyPreferredUsageEnum2 || (CompanyPreferredUsageEnum2 = {}));
/** unique or primary key constraints on table "pl.company_preferred_usage_enum" */
export var CompanyPreferredUsageEnumConstraint;
(function (CompanyPreferredUsageEnumConstraint) {
    /** unique or primary key constraint on columns "name" */
    CompanyPreferredUsageEnumConstraint["CompanyPreferredUsageEnumPkey"] = "company_preferred_usage_enum_pkey";
})(CompanyPreferredUsageEnumConstraint || (CompanyPreferredUsageEnumConstraint = {}));
export var CompanyPreferredUsageEnumEnum;
(function (CompanyPreferredUsageEnumEnum) {
    /** Other */
    CompanyPreferredUsageEnumEnum["Other"] = "_other";
    /** All of the above */
    CompanyPreferredUsageEnumEnum["AllOfTheAbove"] = "all_of_the_above";
    /** E-signing */
    CompanyPreferredUsageEnumEnum["ESigning"] = "e_signing";
    /** Need for all in one platform */
    CompanyPreferredUsageEnumEnum["NeedForAllInOnePlatform"] = "need_for_all_in_one_platform";
    /** Need for contract automation */
    CompanyPreferredUsageEnumEnum["NeedForContractAutomation"] = "need_for_contract_automation";
    /** Need for contract management */
    CompanyPreferredUsageEnumEnum["NeedForContractManagement"] = "need_for_contract_management";
    /** Need for e-signing */
    CompanyPreferredUsageEnumEnum["NeedForESigning"] = "need_for_e_signing";
    /** Need for one agreement */
    CompanyPreferredUsageEnumEnum["NeedForOneAgreement"] = "need_for_one_agreement";
    /** Need for legal template */
    CompanyPreferredUsageEnumEnum["NeedLegalTemplate"] = "need_legal_template";
    /** Work smarter with legal */
    CompanyPreferredUsageEnumEnum["WorkSmarterWithLegal"] = "work_smarter_with_legal";
})(CompanyPreferredUsageEnumEnum || (CompanyPreferredUsageEnumEnum = {}));
/** select columns of table "pl.company_preferred_usage_enum" */
export var CompanyPreferredUsageEnumSelectColumn;
(function (CompanyPreferredUsageEnumSelectColumn) {
    /** column name */
    CompanyPreferredUsageEnumSelectColumn["Description"] = "description";
    /** column name */
    CompanyPreferredUsageEnumSelectColumn["Name"] = "name";
})(CompanyPreferredUsageEnumSelectColumn || (CompanyPreferredUsageEnumSelectColumn = {}));
/** update columns of table "pl.company_preferred_usage_enum" */
export var CompanyPreferredUsageEnumUpdateColumn;
(function (CompanyPreferredUsageEnumUpdateColumn) {
    /** column name */
    CompanyPreferredUsageEnumUpdateColumn["Description"] = "description";
    /** column name */
    CompanyPreferredUsageEnumUpdateColumn["Name"] = "name";
})(CompanyPreferredUsageEnumUpdateColumn || (CompanyPreferredUsageEnumUpdateColumn = {}));
/** select columns of table "pl.company_preferred_usage" */
export var CompanyPreferredUsageSelectColumn;
(function (CompanyPreferredUsageSelectColumn) {
    /** column name */
    CompanyPreferredUsageSelectColumn["CompanyId"] = "company_id";
    /** column name */
    CompanyPreferredUsageSelectColumn["Id"] = "id";
    /** column name */
    CompanyPreferredUsageSelectColumn["PreferredUsage"] = "preferred_usage";
})(CompanyPreferredUsageSelectColumn || (CompanyPreferredUsageSelectColumn = {}));
/** update columns of table "pl.company_preferred_usage" */
export var CompanyPreferredUsageUpdateColumn;
(function (CompanyPreferredUsageUpdateColumn) {
    /** column name */
    CompanyPreferredUsageUpdateColumn["CompanyId"] = "company_id";
    /** column name */
    CompanyPreferredUsageUpdateColumn["Id"] = "id";
    /** column name */
    CompanyPreferredUsageUpdateColumn["PreferredUsage"] = "preferred_usage";
})(CompanyPreferredUsageUpdateColumn || (CompanyPreferredUsageUpdateColumn = {}));
/** unique or primary key constraints on table "pl.company_referral_coupon" */
export var CompanyReferralCouponConstraint;
(function (CompanyReferralCouponConstraint) {
    /** unique or primary key constraint on columns "stripe_coupon_id", "company_id" */
    CompanyReferralCouponConstraint["CompanyReferralCouponCompanyIdStripeCouponIdKey"] = "company_referral_coupon_company_id_stripe_coupon_id_key";
    /** unique or primary key constraint on columns "id" */
    CompanyReferralCouponConstraint["CompanyReferralCouponPkey"] = "company_referral_coupon_pkey";
})(CompanyReferralCouponConstraint || (CompanyReferralCouponConstraint = {}));
/** select columns of table "pl.company_referral_coupon" */
export var CompanyReferralCouponSelectColumn;
(function (CompanyReferralCouponSelectColumn) {
    /** column name */
    CompanyReferralCouponSelectColumn["CompanyId"] = "company_id";
    /** column name */
    CompanyReferralCouponSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    CompanyReferralCouponSelectColumn["Id"] = "id";
    /** column name */
    CompanyReferralCouponSelectColumn["StripeCouponId"] = "stripe_coupon_id";
})(CompanyReferralCouponSelectColumn || (CompanyReferralCouponSelectColumn = {}));
/** update columns of table "pl.company_referral_coupon" */
export var CompanyReferralCouponUpdateColumn;
(function (CompanyReferralCouponUpdateColumn) {
    /** column name */
    CompanyReferralCouponUpdateColumn["CompanyId"] = "company_id";
    /** column name */
    CompanyReferralCouponUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    CompanyReferralCouponUpdateColumn["Id"] = "id";
    /** column name */
    CompanyReferralCouponUpdateColumn["StripeCouponId"] = "stripe_coupon_id";
})(CompanyReferralCouponUpdateColumn || (CompanyReferralCouponUpdateColumn = {}));
/** unique or primary key constraints on table "pl.company_role" */
export var CompanyRoleConstraint;
(function (CompanyRoleConstraint) {
    /** unique or primary key constraint on columns "name" */
    CompanyRoleConstraint["CompanyRolePkey"] = "company_role_pkey";
})(CompanyRoleConstraint || (CompanyRoleConstraint = {}));
export var CompanyRoleEnum;
(function (CompanyRoleEnum) {
    CompanyRoleEnum["Member"] = "member";
    CompanyRoleEnum["Owner"] = "owner";
})(CompanyRoleEnum || (CompanyRoleEnum = {}));
export var CompanyRoleEnum2;
(function (CompanyRoleEnum2) {
    CompanyRoleEnum2["Member"] = "member";
    CompanyRoleEnum2["Owner"] = "owner";
})(CompanyRoleEnum2 || (CompanyRoleEnum2 = {}));
/** select columns of table "pl.company_role" */
export var CompanyRoleSelectColumn;
(function (CompanyRoleSelectColumn) {
    /** column name */
    CompanyRoleSelectColumn["Name"] = "name";
})(CompanyRoleSelectColumn || (CompanyRoleSelectColumn = {}));
/** update columns of table "pl.company_role" */
export var CompanyRoleUpdateColumn;
(function (CompanyRoleUpdateColumn) {
    /** column name */
    CompanyRoleUpdateColumn["Name"] = "name";
})(CompanyRoleUpdateColumn || (CompanyRoleUpdateColumn = {}));
/** select columns of table "pl.company" */
export var CompanySelectColumn;
(function (CompanySelectColumn) {
    /** column name */
    CompanySelectColumn["AddressCity"] = "address_city";
    /** column name */
    CompanySelectColumn["AddressCountry"] = "address_country";
    /** column name */
    CompanySelectColumn["AddressStreet"] = "address_street";
    /** column name */
    CompanySelectColumn["AddressZip"] = "address_zip";
    /** column name */
    CompanySelectColumn["AnnualRevenueRange"] = "annual_revenue_range";
    /** column name */
    CompanySelectColumn["BusinessType"] = "business_type";
    /** column name */
    CompanySelectColumn["CreatedAt"] = "created_at";
    /** column name */
    CompanySelectColumn["DefaultNoticeDateNotificationReceiverId"] = "default_notice_date_notification_receiver_id";
    /** column name */
    CompanySelectColumn["EmployeeCount"] = "employee_count";
    /** column name */
    CompanySelectColumn["Id"] = "id";
    /** column name */
    CompanySelectColumn["Industry"] = "industry";
    /** column name */
    CompanySelectColumn["IndustryOther"] = "industry_other";
    /** column name */
    CompanySelectColumn["LogoPath"] = "logo_path";
    /** column name */
    CompanySelectColumn["LogoUploaded"] = "logo_uploaded";
    /** column name */
    CompanySelectColumn["MarketCode"] = "market_code";
    /** column name */
    CompanySelectColumn["Name"] = "name";
    /** column name */
    CompanySelectColumn["OrganizationNumber"] = "organization_number";
    /** column name */
    CompanySelectColumn["PreferredUsage"] = "preferred_usage";
    /** column name */
    CompanySelectColumn["ReferrerId"] = "referrer_id";
    /** column name */
    CompanySelectColumn["SsoEnterprise"] = "sso_enterprise";
    /** column name */
    CompanySelectColumn["SsoEnterpriseSamlpConnectionId"] = "sso_enterprise_samlp_connection_id";
    /** column name */
    CompanySelectColumn["StripeCustomerId"] = "stripe_customer_id";
    /** column name */
    CompanySelectColumn["UpdatedAt"] = "updated_at";
    /** column name */
    CompanySelectColumn["WebDomain"] = "web_domain";
    /** column name */
    CompanySelectColumn["YearFounded"] = "year_founded";
})(CompanySelectColumn || (CompanySelectColumn = {}));
/** select "pl_company_aggregate_bool_exp_bool_and_arguments_columns" columns of table "pl.company" */
export var CompanySelectColumnPlCompanyAggregateBoolExpBoolAndArgumentsColumns;
(function (CompanySelectColumnPlCompanyAggregateBoolExpBoolAndArgumentsColumns) {
    /** column name */
    CompanySelectColumnPlCompanyAggregateBoolExpBoolAndArgumentsColumns["LogoUploaded"] = "logo_uploaded";
    /** column name */
    CompanySelectColumnPlCompanyAggregateBoolExpBoolAndArgumentsColumns["SsoEnterprise"] = "sso_enterprise";
})(CompanySelectColumnPlCompanyAggregateBoolExpBoolAndArgumentsColumns || (CompanySelectColumnPlCompanyAggregateBoolExpBoolAndArgumentsColumns = {}));
/** select "pl_company_aggregate_bool_exp_bool_or_arguments_columns" columns of table "pl.company" */
export var CompanySelectColumnPlCompanyAggregateBoolExpBoolOrArgumentsColumns;
(function (CompanySelectColumnPlCompanyAggregateBoolExpBoolOrArgumentsColumns) {
    /** column name */
    CompanySelectColumnPlCompanyAggregateBoolExpBoolOrArgumentsColumns["LogoUploaded"] = "logo_uploaded";
    /** column name */
    CompanySelectColumnPlCompanyAggregateBoolExpBoolOrArgumentsColumns["SsoEnterprise"] = "sso_enterprise";
})(CompanySelectColumnPlCompanyAggregateBoolExpBoolOrArgumentsColumns || (CompanySelectColumnPlCompanyAggregateBoolExpBoolOrArgumentsColumns = {}));
/** update columns of table "pl.company" */
export var CompanyUpdateColumn;
(function (CompanyUpdateColumn) {
    /** column name */
    CompanyUpdateColumn["AddressCity"] = "address_city";
    /** column name */
    CompanyUpdateColumn["AddressCountry"] = "address_country";
    /** column name */
    CompanyUpdateColumn["AddressStreet"] = "address_street";
    /** column name */
    CompanyUpdateColumn["AddressZip"] = "address_zip";
    /** column name */
    CompanyUpdateColumn["AnnualRevenueRange"] = "annual_revenue_range";
    /** column name */
    CompanyUpdateColumn["BusinessType"] = "business_type";
    /** column name */
    CompanyUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    CompanyUpdateColumn["DefaultNoticeDateNotificationReceiverId"] = "default_notice_date_notification_receiver_id";
    /** column name */
    CompanyUpdateColumn["EmployeeCount"] = "employee_count";
    /** column name */
    CompanyUpdateColumn["Id"] = "id";
    /** column name */
    CompanyUpdateColumn["Industry"] = "industry";
    /** column name */
    CompanyUpdateColumn["IndustryOther"] = "industry_other";
    /** column name */
    CompanyUpdateColumn["LogoPath"] = "logo_path";
    /** column name */
    CompanyUpdateColumn["LogoUploaded"] = "logo_uploaded";
    /** column name */
    CompanyUpdateColumn["MarketCode"] = "market_code";
    /** column name */
    CompanyUpdateColumn["Name"] = "name";
    /** column name */
    CompanyUpdateColumn["OrganizationNumber"] = "organization_number";
    /** column name */
    CompanyUpdateColumn["PreferredUsage"] = "preferred_usage";
    /** column name */
    CompanyUpdateColumn["ReferrerId"] = "referrer_id";
    /** column name */
    CompanyUpdateColumn["SsoEnterprise"] = "sso_enterprise";
    /** column name */
    CompanyUpdateColumn["SsoEnterpriseSamlpConnectionId"] = "sso_enterprise_samlp_connection_id";
    /** column name */
    CompanyUpdateColumn["StripeCustomerId"] = "stripe_customer_id";
    /** column name */
    CompanyUpdateColumn["UpdatedAt"] = "updated_at";
    /** column name */
    CompanyUpdateColumn["WebDomain"] = "web_domain";
    /** column name */
    CompanyUpdateColumn["YearFounded"] = "year_founded";
})(CompanyUpdateColumn || (CompanyUpdateColumn = {}));
/** unique or primary key constraints on table "pl.company_user" */
export var CompanyUserConstraint;
(function (CompanyUserConstraint) {
    /** unique or primary key constraint on columns "user_id", "company_id" */
    CompanyUserConstraint["CompanyUserCompanyIdUserIdKey"] = "company_user_company_id_user_id_key";
    /** unique or primary key constraint on columns "id" */
    CompanyUserConstraint["CompanyUserPkey"] = "company_user_pkey";
})(CompanyUserConstraint || (CompanyUserConstraint = {}));
export var CompanyUserJobTitleEnum2;
(function (CompanyUserJobTitleEnum2) {
    CompanyUserJobTitleEnum2["Other"] = "_other";
    CompanyUserJobTitleEnum2["Ceo"] = "ceo";
    CompanyUserJobTitleEnum2["Finance"] = "finance";
    CompanyUserJobTitleEnum2["Founder"] = "founder";
    CompanyUserJobTitleEnum2["GeneralManagement"] = "general_management";
    CompanyUserJobTitleEnum2["HumanResources"] = "human_resources";
    CompanyUserJobTitleEnum2["LegalCompliance"] = "legal_compliance";
    CompanyUserJobTitleEnum2["Marketing"] = "marketing";
    CompanyUserJobTitleEnum2["Operations"] = "operations";
    CompanyUserJobTitleEnum2["ProductTechRnd"] = "product_tech_rnd";
    CompanyUserJobTitleEnum2["Sales"] = "sales";
})(CompanyUserJobTitleEnum2 || (CompanyUserJobTitleEnum2 = {}));
/** unique or primary key constraints on table "pl.company_user_job_title_enum" */
export var CompanyUserJobTitleEnumConstraint;
(function (CompanyUserJobTitleEnumConstraint) {
    /** unique or primary key constraint on columns "name" */
    CompanyUserJobTitleEnumConstraint["CompanyUserJobTitleEnumPkey"] = "company_user_job_title_enum_pkey";
})(CompanyUserJobTitleEnumConstraint || (CompanyUserJobTitleEnumConstraint = {}));
export var CompanyUserJobTitleEnumEnum;
(function (CompanyUserJobTitleEnumEnum) {
    /** Other */
    CompanyUserJobTitleEnumEnum["Other"] = "_other";
    /** CEO */
    CompanyUserJobTitleEnumEnum["Ceo"] = "ceo";
    /** Finance */
    CompanyUserJobTitleEnumEnum["Finance"] = "finance";
    /** Founder */
    CompanyUserJobTitleEnumEnum["Founder"] = "founder";
    /** General Management */
    CompanyUserJobTitleEnumEnum["GeneralManagement"] = "general_management";
    /** Human Resources */
    CompanyUserJobTitleEnumEnum["HumanResources"] = "human_resources";
    /** Legal and Compliance */
    CompanyUserJobTitleEnumEnum["LegalCompliance"] = "legal_compliance";
    /** Marketing */
    CompanyUserJobTitleEnumEnum["Marketing"] = "marketing";
    /** Operations */
    CompanyUserJobTitleEnumEnum["Operations"] = "operations";
    /** Product/Tech/R&D */
    CompanyUserJobTitleEnumEnum["ProductTechRnd"] = "product_tech_rnd";
    /** Sales */
    CompanyUserJobTitleEnumEnum["Sales"] = "sales";
})(CompanyUserJobTitleEnumEnum || (CompanyUserJobTitleEnumEnum = {}));
/** select columns of table "pl.company_user_job_title_enum" */
export var CompanyUserJobTitleEnumSelectColumn;
(function (CompanyUserJobTitleEnumSelectColumn) {
    /** column name */
    CompanyUserJobTitleEnumSelectColumn["Description"] = "description";
    /** column name */
    CompanyUserJobTitleEnumSelectColumn["Name"] = "name";
})(CompanyUserJobTitleEnumSelectColumn || (CompanyUserJobTitleEnumSelectColumn = {}));
/** update columns of table "pl.company_user_job_title_enum" */
export var CompanyUserJobTitleEnumUpdateColumn;
(function (CompanyUserJobTitleEnumUpdateColumn) {
    /** column name */
    CompanyUserJobTitleEnumUpdateColumn["Description"] = "description";
    /** column name */
    CompanyUserJobTitleEnumUpdateColumn["Name"] = "name";
})(CompanyUserJobTitleEnumUpdateColumn || (CompanyUserJobTitleEnumUpdateColumn = {}));
/** select columns of table "pl.company_user" */
export var CompanyUserSelectColumn;
(function (CompanyUserSelectColumn) {
    /** column name */
    CompanyUserSelectColumn["CanManageMember"] = "can_manage_member";
    /** column name */
    CompanyUserSelectColumn["CompanyId"] = "company_id";
    /** column name */
    CompanyUserSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    CompanyUserSelectColumn["Id"] = "id";
    /** column name */
    CompanyUserSelectColumn["JobTitle"] = "job_title";
    /** column name */
    CompanyUserSelectColumn["JobTitleOther"] = "job_title_other";
    /** column name */
    CompanyUserSelectColumn["Role"] = "role";
    /** column name */
    CompanyUserSelectColumn["UpdatedAt"] = "updated_at";
    /** column name */
    CompanyUserSelectColumn["UserId"] = "user_id";
})(CompanyUserSelectColumn || (CompanyUserSelectColumn = {}));
/** select "pl_company_user_aggregate_bool_exp_bool_and_arguments_columns" columns of table "pl.company_user" */
export var CompanyUserSelectColumnPlCompanyUserAggregateBoolExpBoolAndArgumentsColumns;
(function (CompanyUserSelectColumnPlCompanyUserAggregateBoolExpBoolAndArgumentsColumns) {
    /** column name */
    CompanyUserSelectColumnPlCompanyUserAggregateBoolExpBoolAndArgumentsColumns["CanManageMember"] = "can_manage_member";
})(CompanyUserSelectColumnPlCompanyUserAggregateBoolExpBoolAndArgumentsColumns || (CompanyUserSelectColumnPlCompanyUserAggregateBoolExpBoolAndArgumentsColumns = {}));
/** select "pl_company_user_aggregate_bool_exp_bool_or_arguments_columns" columns of table "pl.company_user" */
export var CompanyUserSelectColumnPlCompanyUserAggregateBoolExpBoolOrArgumentsColumns;
(function (CompanyUserSelectColumnPlCompanyUserAggregateBoolExpBoolOrArgumentsColumns) {
    /** column name */
    CompanyUserSelectColumnPlCompanyUserAggregateBoolExpBoolOrArgumentsColumns["CanManageMember"] = "can_manage_member";
})(CompanyUserSelectColumnPlCompanyUserAggregateBoolExpBoolOrArgumentsColumns || (CompanyUserSelectColumnPlCompanyUserAggregateBoolExpBoolOrArgumentsColumns = {}));
/** update columns of table "pl.company_user" */
export var CompanyUserUpdateColumn;
(function (CompanyUserUpdateColumn) {
    /** column name */
    CompanyUserUpdateColumn["CanManageMember"] = "can_manage_member";
    /** column name */
    CompanyUserUpdateColumn["CompanyId"] = "company_id";
    /** column name */
    CompanyUserUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    CompanyUserUpdateColumn["Id"] = "id";
    /** column name */
    CompanyUserUpdateColumn["JobTitle"] = "job_title";
    /** column name */
    CompanyUserUpdateColumn["JobTitleOther"] = "job_title_other";
    /** column name */
    CompanyUserUpdateColumn["Role"] = "role";
    /** column name */
    CompanyUserUpdateColumn["UpdatedAt"] = "updated_at";
    /** column name */
    CompanyUserUpdateColumn["UserId"] = "user_id";
})(CompanyUserUpdateColumn || (CompanyUserUpdateColumn = {}));
/** select columns of table "pl.company_users_view" */
export var CompanyUsersViewSelectColumn;
(function (CompanyUsersViewSelectColumn) {
    /** column name */
    CompanyUsersViewSelectColumn["CompanyId"] = "company_id";
    /** column name */
    CompanyUsersViewSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    CompanyUsersViewSelectColumn["Email"] = "email";
    /** column name */
    CompanyUsersViewSelectColumn["Id"] = "id";
    /** column name */
    CompanyUsersViewSelectColumn["Name"] = "name";
    /** column name */
    CompanyUsersViewSelectColumn["UpdatedAt"] = "updated_at";
})(CompanyUsersViewSelectColumn || (CompanyUsersViewSelectColumn = {}));
export var ConnectCompanyEsigningProviderRejectionReason;
(function (ConnectCompanyEsigningProviderRejectionReason) {
    ConnectCompanyEsigningProviderRejectionReason["AlreadyConnectedToEsigningProvider"] = "ALREADY_CONNECTED_TO_ESIGNING_PROVIDER";
    ConnectCompanyEsigningProviderRejectionReason["NotAuthorized"] = "NOT_AUTHORIZED";
    ConnectCompanyEsigningProviderRejectionReason["UnknownEsigningProvider"] = "UNKNOWN_ESIGNING_PROVIDER";
})(ConnectCompanyEsigningProviderRejectionReason || (ConnectCompanyEsigningProviderRejectionReason = {}));
export var CreateDocumentMetadataCustomPropertyPresetEnum;
(function (CreateDocumentMetadataCustomPropertyPresetEnum) {
    /** Date picker */
    CreateDocumentMetadataCustomPropertyPresetEnum["DatePicker"] = "DatePicker";
    /** Date and time picker */
    CreateDocumentMetadataCustomPropertyPresetEnum["DateTimePicker"] = "DateTimePicker";
    /** Number input with decimal places */
    CreateDocumentMetadataCustomPropertyPresetEnum["InputFloatNumber"] = "InputFloatNumber";
    /** Number input without decimal places (integer) */
    CreateDocumentMetadataCustomPropertyPresetEnum["InputIntegerNumber"] = "InputIntegerNumber";
    /** Single line text input */
    CreateDocumentMetadataCustomPropertyPresetEnum["InputText"] = "InputText";
    /** Multi select dropdown from a list */
    CreateDocumentMetadataCustomPropertyPresetEnum["SelectMultiFromList"] = "SelectMultiFromList";
    /** Multi select dropdown for referencing multiple other documents/users */
    CreateDocumentMetadataCustomPropertyPresetEnum["SelectMultiReference"] = "SelectMultiReference";
    /** Single select dropdown from a list */
    CreateDocumentMetadataCustomPropertyPresetEnum["SelectSingleFromList"] = "SelectSingleFromList";
    /** Single select dropdown for referencing one other document/user */
    CreateDocumentMetadataCustomPropertyPresetEnum["SelectSingleReference"] = "SelectSingleReference";
    CreateDocumentMetadataCustomPropertyPresetEnum["SelectWithInput"] = "SelectWithInput";
    /** Toggle switch */
    CreateDocumentMetadataCustomPropertyPresetEnum["Switch"] = "Switch";
    /** Multi line text input */
    CreateDocumentMetadataCustomPropertyPresetEnum["TextArea"] = "TextArea";
})(CreateDocumentMetadataCustomPropertyPresetEnum || (CreateDocumentMetadataCustomPropertyPresetEnum = {}));
export var CreateEsigningRecipientValueRejectionReason;
(function (CreateEsigningRecipientValueRejectionReason) {
    CreateEsigningRecipientValueRejectionReason["CannotNormalizeNames"] = "CANNOT_NORMALIZE_NAMES";
    CreateEsigningRecipientValueRejectionReason["MissingMobileNumber"] = "MISSING_MOBILE_NUMBER";
    CreateEsigningRecipientValueRejectionReason["NotAuthorized"] = "NOT_AUTHORIZED";
    CreateEsigningRecipientValueRejectionReason["NotFound"] = "NOT_FOUND";
})(CreateEsigningRecipientValueRejectionReason || (CreateEsigningRecipientValueRejectionReason = {}));
export var CreateSignRequestRejectionReason;
(function (CreateSignRequestRejectionReason) {
    CreateSignRequestRejectionReason["ActiveSignRequest"] = "ACTIVE_SIGN_REQUEST";
    CreateSignRequestRejectionReason["ApproversNotSupportedByProvider"] = "APPROVERS_NOT_SUPPORTED_BY_PROVIDER";
    CreateSignRequestRejectionReason["Failed"] = "FAILED";
    CreateSignRequestRejectionReason["InvalidOrder"] = "INVALID_ORDER";
    CreateSignRequestRejectionReason["MaximumRecipientLimit"] = "MAXIMUM_RECIPIENT_LIMIT";
    CreateSignRequestRejectionReason["MissingMobileNumber"] = "MISSING_MOBILE_NUMBER";
    CreateSignRequestRejectionReason["MissingPdfFile"] = "MISSING_PDF_FILE";
    CreateSignRequestRejectionReason["MissingSignatories"] = "MISSING_SIGNATORIES";
    CreateSignRequestRejectionReason["NotAuthorized"] = "NOT_AUTHORIZED";
    CreateSignRequestRejectionReason["NotConnectedToEsigningProvider"] = "NOT_CONNECTED_TO_ESIGNING_PROVIDER";
    CreateSignRequestRejectionReason["NotEnoughCredits"] = "NOT_ENOUGH_CREDITS";
    CreateSignRequestRejectionReason["ProviderExpectsFirstNameLastName"] = "PROVIDER_EXPECTS_FIRST_NAME_LAST_NAME";
    CreateSignRequestRejectionReason["ProviderExpectsName"] = "PROVIDER_EXPECTS_NAME";
    CreateSignRequestRejectionReason["TotalDocumentSizeLimit"] = "TOTAL_DOCUMENT_SIZE_LIMIT";
    CreateSignRequestRejectionReason["UnsupportedAuthenticationMode"] = "UNSUPPORTED_AUTHENTICATION_MODE";
})(CreateSignRequestRejectionReason || (CreateSignRequestRejectionReason = {}));
/** ordering argument of a cursor */
export var CursorOrdering;
(function (CursorOrdering) {
    /** ascending ordering of the cursor */
    CursorOrdering["Asc"] = "ASC";
    /** descending ordering of the cursor */
    CursorOrdering["Desc"] = "DESC";
})(CursorOrdering || (CursorOrdering = {}));
export var DateFormat;
(function (DateFormat) {
    DateFormat["Ddmmyyyy"] = "DDMMYYYY";
    DateFormat["Mmddyyyy"] = "MMDDYYYY";
    DateFormat["Yyyymmdd"] = "YYYYMMDD";
})(DateFormat || (DateFormat = {}));
export var DateSeparator;
(function (DateSeparator) {
    DateSeparator["Dot"] = "DOT";
    DateSeparator["ForwardSlash"] = "FORWARD_SLASH";
    DateSeparator["Hyphen"] = "HYPHEN";
})(DateSeparator || (DateSeparator = {}));
export var DeleteEsigningRecipientValueRejectionReason;
(function (DeleteEsigningRecipientValueRejectionReason) {
    DeleteEsigningRecipientValueRejectionReason["NotAuthorized"] = "NOT_AUTHORIZED";
})(DeleteEsigningRecipientValueRejectionReason || (DeleteEsigningRecipientValueRejectionReason = {}));
export var DisableEsigningFeatureRejectionReason;
(function (DisableEsigningFeatureRejectionReason) {
    DisableEsigningFeatureRejectionReason["NotAuthorized"] = "NOT_AUTHORIZED";
})(DisableEsigningFeatureRejectionReason || (DisableEsigningFeatureRejectionReason = {}));
export var DisconnectCompanyEsigningProviderRejectionReason;
(function (DisconnectCompanyEsigningProviderRejectionReason) {
    DisconnectCompanyEsigningProviderRejectionReason["NotAuthorized"] = "NOT_AUTHORIZED";
    DisconnectCompanyEsigningProviderRejectionReason["NotFound"] = "NOT_FOUND";
    DisconnectCompanyEsigningProviderRejectionReason["PendingSignRequests"] = "PENDING_SIGN_REQUESTS";
})(DisconnectCompanyEsigningProviderRejectionReason || (DisconnectCompanyEsigningProviderRejectionReason = {}));
export var DistinctOnUserInputInput2;
(function (DistinctOnUserInputInput2) {
    DistinctOnUserInputInput2["Email"] = "email";
})(DistinctOnUserInputInput2 || (DistinctOnUserInputInput2 = {}));
export var DocumentAiDisabledReason;
(function (DocumentAiDisabledReason) {
    DocumentAiDisabledReason["TextExtractionFailed"] = "TEXT_EXTRACTION_FAILED";
    DocumentAiDisabledReason["TextExtractionPending"] = "TEXT_EXTRACTION_PENDING";
})(DocumentAiDisabledReason || (DocumentAiDisabledReason = {}));
export var DocumentMetadataAiAutoTaggingQueueEntryStatus;
(function (DocumentMetadataAiAutoTaggingQueueEntryStatus) {
    DocumentMetadataAiAutoTaggingQueueEntryStatus["Canceled"] = "CANCELED";
    DocumentMetadataAiAutoTaggingQueueEntryStatus["Delayed"] = "DELAYED";
    DocumentMetadataAiAutoTaggingQueueEntryStatus["Failed"] = "FAILED";
    DocumentMetadataAiAutoTaggingQueueEntryStatus["InProgress"] = "IN_PROGRESS";
    DocumentMetadataAiAutoTaggingQueueEntryStatus["Pending"] = "PENDING";
    DocumentMetadataAiAutoTaggingQueueEntryStatus["Success"] = "SUCCESS";
})(DocumentMetadataAiAutoTaggingQueueEntryStatus || (DocumentMetadataAiAutoTaggingQueueEntryStatus = {}));
export var DocumentMetadataBulkSetPairsOperationType;
(function (DocumentMetadataBulkSetPairsOperationType) {
    DocumentMetadataBulkSetPairsOperationType["Clear"] = "CLEAR";
    DocumentMetadataBulkSetPairsOperationType["Set"] = "SET";
})(DocumentMetadataBulkSetPairsOperationType || (DocumentMetadataBulkSetPairsOperationType = {}));
export var DocumentMetadataCustomPropertyInternalDataTypeEnum;
(function (DocumentMetadataCustomPropertyInternalDataTypeEnum) {
    DocumentMetadataCustomPropertyInternalDataTypeEnum["CustomPropertyBoolean"] = "CustomPropertyBoolean";
    DocumentMetadataCustomPropertyInternalDataTypeEnum["CustomPropertyDate"] = "CustomPropertyDate";
    DocumentMetadataCustomPropertyInternalDataTypeEnum["CustomPropertyFloat"] = "CustomPropertyFloat";
    DocumentMetadataCustomPropertyInternalDataTypeEnum["CustomPropertyKeyword"] = "CustomPropertyKeyword";
    DocumentMetadataCustomPropertyInternalDataTypeEnum["CustomPropertyKeywordArray"] = "CustomPropertyKeywordArray";
    DocumentMetadataCustomPropertyInternalDataTypeEnum["CustomPropertyNumber"] = "CustomPropertyNumber";
    DocumentMetadataCustomPropertyInternalDataTypeEnum["CustomPropertyText"] = "CustomPropertyText";
    DocumentMetadataCustomPropertyInternalDataTypeEnum["CustomPropertyTextArray"] = "CustomPropertyTextArray";
})(DocumentMetadataCustomPropertyInternalDataTypeEnum || (DocumentMetadataCustomPropertyInternalDataTypeEnum = {}));
export var DocumentMetadataFeature;
(function (DocumentMetadataFeature) {
    DocumentMetadataFeature["AiAutoTagging"] = "AI_AUTO_TAGGING";
    DocumentMetadataFeature["CustomProperties"] = "CUSTOM_PROPERTIES";
})(DocumentMetadataFeature || (DocumentMetadataFeature = {}));
export var DocumentMetadataPropertyReferenceEnum;
(function (DocumentMetadataPropertyReferenceEnum) {
    DocumentMetadataPropertyReferenceEnum["FileSystemDocument"] = "fileSystemDocument";
    DocumentMetadataPropertyReferenceEnum["FileSystemEntry"] = "fileSystemEntry";
    DocumentMetadataPropertyReferenceEnum["FileSystemFolder"] = "fileSystemFolder";
    DocumentMetadataPropertyReferenceEnum["User"] = "user";
})(DocumentMetadataPropertyReferenceEnum || (DocumentMetadataPropertyReferenceEnum = {}));
export var DocumentMetadataPropertySetterEnum;
(function (DocumentMetadataPropertySetterEnum) {
    DocumentMetadataPropertySetterEnum["Ai"] = "AI";
    DocumentMetadataPropertySetterEnum["System"] = "SYSTEM";
    DocumentMetadataPropertySetterEnum["User"] = "USER";
})(DocumentMetadataPropertySetterEnum || (DocumentMetadataPropertySetterEnum = {}));
export var DocumentMetadataPropertyTypeEnum;
(function (DocumentMetadataPropertyTypeEnum) {
    DocumentMetadataPropertyTypeEnum["Boolean"] = "boolean";
    DocumentMetadataPropertyTypeEnum["Date"] = "date";
    DocumentMetadataPropertyTypeEnum["Datetime"] = "datetime";
    DocumentMetadataPropertyTypeEnum["List"] = "list";
    DocumentMetadataPropertyTypeEnum["MultiLineText"] = "multiLineText";
    DocumentMetadataPropertyTypeEnum["Number"] = "number";
    DocumentMetadataPropertyTypeEnum["Reference"] = "reference";
    DocumentMetadataPropertyTypeEnum["SimpleText"] = "simpleText";
})(DocumentMetadataPropertyTypeEnum || (DocumentMetadataPropertyTypeEnum = {}));
export var DocumentMetadataPropertyUiWidgetHintEnum;
(function (DocumentMetadataPropertyUiWidgetHintEnum) {
    DocumentMetadataPropertyUiWidgetHintEnum["DatePicker"] = "DatePicker";
    DocumentMetadataPropertyUiWidgetHintEnum["DateTimePicker"] = "DateTimePicker";
    DocumentMetadataPropertyUiWidgetHintEnum["InputNumber"] = "InputNumber";
    DocumentMetadataPropertyUiWidgetHintEnum["InputText"] = "InputText";
    DocumentMetadataPropertyUiWidgetHintEnum["Select"] = "Select";
    DocumentMetadataPropertyUiWidgetHintEnum["SelectWithInput"] = "SelectWithInput";
    DocumentMetadataPropertyUiWidgetHintEnum["Switch"] = "Switch";
    DocumentMetadataPropertyUiWidgetHintEnum["TextArea"] = "TextArea";
})(DocumentMetadataPropertyUiWidgetHintEnum || (DocumentMetadataPropertyUiWidgetHintEnum = {}));
export var DocumentType;
(function (DocumentType) {
    DocumentType["Composed"] = "COMPOSED";
    DocumentType["Freetext"] = "FREETEXT";
    DocumentType["Unknown"] = "UNKNOWN";
    DocumentType["Uploaded"] = "UPLOADED";
})(DocumentType || (DocumentType = {}));
export var DocumentUploadJobStatus;
(function (DocumentUploadJobStatus) {
    DocumentUploadJobStatus["Done"] = "DONE";
    DocumentUploadJobStatus["Failed"] = "FAILED";
    DocumentUploadJobStatus["Pending"] = "PENDING";
    DocumentUploadJobStatus["Processing"] = "PROCESSING";
})(DocumentUploadJobStatus || (DocumentUploadJobStatus = {}));
export var EnableEsigningFeatureRejectionReason;
(function (EnableEsigningFeatureRejectionReason) {
    EnableEsigningFeatureRejectionReason["NotAuthorized"] = "NOT_AUTHORIZED";
})(EnableEsigningFeatureRejectionReason || (EnableEsigningFeatureRejectionReason = {}));
export var EntityType;
(function (EntityType) {
    EntityType["Attachment"] = "ATTACHMENT";
    EntityType["CompanyLogo"] = "COMPANY_LOGO";
    EntityType["Document"] = "DOCUMENT";
})(EntityType || (EntityType = {}));
export var EntryKind;
(function (EntryKind) {
    EntryKind["Document"] = "DOCUMENT";
    EntryKind["Entry"] = "ENTRY";
    EntryKind["Folder"] = "FOLDER";
})(EntryKind || (EntryKind = {}));
export var EsigningActivityCategory;
(function (EsigningActivityCategory) {
    EsigningActivityCategory["ApprovalRequest"] = "ApprovalRequest";
    EsigningActivityCategory["SignRequest"] = "SignRequest";
})(EsigningActivityCategory || (EsigningActivityCategory = {}));
export var EsigningAttachmentKind;
(function (EsigningAttachmentKind) {
    EsigningAttachmentKind["Default"] = "DEFAULT";
    EsigningAttachmentKind["Document"] = "DOCUMENT";
    EsigningAttachmentKind["SignRequest"] = "SIGN_REQUEST";
})(EsigningAttachmentKind || (EsigningAttachmentKind = {}));
export var EsigningFeatureSlug;
(function (EsigningFeatureSlug) {
    EsigningFeatureSlug["Approval"] = "APPROVAL";
    EsigningFeatureSlug["DefaultAttachments"] = "DEFAULT_ATTACHMENTS";
    EsigningFeatureSlug["DefaultSignatories"] = "DEFAULT_SIGNATORIES";
})(EsigningFeatureSlug || (EsigningFeatureSlug = {}));
export var EsigningProviderAuthenticationModeSlug;
(function (EsigningProviderAuthenticationModeSlug) {
    EsigningProviderAuthenticationModeSlug["Email"] = "EMAIL";
    EsigningProviderAuthenticationModeSlug["FinBankid"] = "FIN_BANKID";
    EsigningProviderAuthenticationModeSlug["Freja"] = "FREJA";
    EsigningProviderAuthenticationModeSlug["Mitid"] = "MITID";
    EsigningProviderAuthenticationModeSlug["NorBankid"] = "NOR_BANKID";
    EsigningProviderAuthenticationModeSlug["SmartId"] = "SMART_ID";
    EsigningProviderAuthenticationModeSlug["SmsOtp"] = "SMS_OTP";
    EsigningProviderAuthenticationModeSlug["SweBankid"] = "SWE_BANKID";
    EsigningProviderAuthenticationModeSlug["Unsupported"] = "UNSUPPORTED";
})(EsigningProviderAuthenticationModeSlug || (EsigningProviderAuthenticationModeSlug = {}));
export var EsigningRecipientType;
(function (EsigningRecipientType) {
    EsigningRecipientType["Approver"] = "APPROVER";
    EsigningRecipientType["Signatory"] = "SIGNATORY";
    EsigningRecipientType["Viewer"] = "VIEWER";
})(EsigningRecipientType || (EsigningRecipientType = {}));
export var ExternalApproveDocumentRejectionReason;
(function (ExternalApproveDocumentRejectionReason) {
    ExternalApproveDocumentRejectionReason["Unknown"] = "UNKNOWN";
    ExternalApproveDocumentRejectionReason["Upstream"] = "UPSTREAM";
    ExternalApproveDocumentRejectionReason["Validation"] = "VALIDATION";
})(ExternalApproveDocumentRejectionReason || (ExternalApproveDocumentRejectionReason = {}));
export var ExternalAuthenticationOptionsRejectionReason;
(function (ExternalAuthenticationOptionsRejectionReason) {
    ExternalAuthenticationOptionsRejectionReason["Unknown"] = "UNKNOWN";
    ExternalAuthenticationOptionsRejectionReason["Upstream"] = "UPSTREAM";
    ExternalAuthenticationOptionsRejectionReason["Validation"] = "VALIDATION";
})(ExternalAuthenticationOptionsRejectionReason || (ExternalAuthenticationOptionsRejectionReason = {}));
export var ExternalAuthenticationOptionsSignatoryRole;
(function (ExternalAuthenticationOptionsSignatoryRole) {
    ExternalAuthenticationOptionsSignatoryRole["Approver"] = "APPROVER";
    ExternalAuthenticationOptionsSignatoryRole["Signer"] = "SIGNER";
    ExternalAuthenticationOptionsSignatoryRole["Viewer"] = "VIEWER";
})(ExternalAuthenticationOptionsSignatoryRole || (ExternalAuthenticationOptionsSignatoryRole = {}));
export var ExternalAuthenticationOptionsSignatureEvidenceType;
(function (ExternalAuthenticationOptionsSignatureEvidenceType) {
    ExternalAuthenticationOptionsSignatureEvidenceType["Drawable"] = "DRAWABLE";
    ExternalAuthenticationOptionsSignatureEvidenceType["Verified"] = "VERIFIED";
})(ExternalAuthenticationOptionsSignatureEvidenceType || (ExternalAuthenticationOptionsSignatureEvidenceType = {}));
export var ExternalCompleteVerificationRejectionReason;
(function (ExternalCompleteVerificationRejectionReason) {
    ExternalCompleteVerificationRejectionReason["Unknown"] = "UNKNOWN";
    ExternalCompleteVerificationRejectionReason["Upstream"] = "UPSTREAM";
    ExternalCompleteVerificationRejectionReason["Validation"] = "VALIDATION";
})(ExternalCompleteVerificationRejectionReason || (ExternalCompleteVerificationRejectionReason = {}));
export var ExternalOpenDocumentRejectionReason;
(function (ExternalOpenDocumentRejectionReason) {
    ExternalOpenDocumentRejectionReason["Unknown"] = "UNKNOWN";
    ExternalOpenDocumentRejectionReason["Upstream"] = "UPSTREAM";
    ExternalOpenDocumentRejectionReason["Validation"] = "VALIDATION";
})(ExternalOpenDocumentRejectionReason || (ExternalOpenDocumentRejectionReason = {}));
export var ExternalRejectRejectionReason;
(function (ExternalRejectRejectionReason) {
    ExternalRejectRejectionReason["Unknown"] = "UNKNOWN";
    ExternalRejectRejectionReason["Upstream"] = "UPSTREAM";
    ExternalRejectRejectionReason["Validation"] = "VALIDATION";
})(ExternalRejectRejectionReason || (ExternalRejectRejectionReason = {}));
export var ExternalSharingInviteStatusEnum;
(function (ExternalSharingInviteStatusEnum) {
    ExternalSharingInviteStatusEnum["Claimed"] = "CLAIMED";
    ExternalSharingInviteStatusEnum["Unclaimed"] = "UNCLAIMED";
})(ExternalSharingInviteStatusEnum || (ExternalSharingInviteStatusEnum = {}));
export var ExternalSignRejectionReason;
(function (ExternalSignRejectionReason) {
    ExternalSignRejectionReason["Unknown"] = "UNKNOWN";
    ExternalSignRejectionReason["Upstream"] = "UPSTREAM";
    ExternalSignRejectionReason["Validation"] = "VALIDATION";
})(ExternalSignRejectionReason || (ExternalSignRejectionReason = {}));
export var ExternalSignRequestActorRole;
(function (ExternalSignRequestActorRole) {
    ExternalSignRequestActorRole["Approver"] = "APPROVER";
    ExternalSignRequestActorRole["Signer"] = "SIGNER";
    ExternalSignRequestActorRole["Viewer"] = "VIEWER";
})(ExternalSignRequestActorRole || (ExternalSignRequestActorRole = {}));
export var ExternalSignRequestApproverStatus;
(function (ExternalSignRequestApproverStatus) {
    ExternalSignRequestApproverStatus["Approved"] = "APPROVED";
    ExternalSignRequestApproverStatus["Deleted"] = "DELETED";
    ExternalSignRequestApproverStatus["Error"] = "ERROR";
    ExternalSignRequestApproverStatus["Open"] = "OPEN";
    ExternalSignRequestApproverStatus["Rejected"] = "REJECTED";
})(ExternalSignRequestApproverStatus || (ExternalSignRequestApproverStatus = {}));
export var ExternalSignRequestDocumentKind;
(function (ExternalSignRequestDocumentKind) {
    ExternalSignRequestDocumentKind["Attachment"] = "ATTACHMENT";
    ExternalSignRequestDocumentKind["Document"] = "DOCUMENT";
})(ExternalSignRequestDocumentKind || (ExternalSignRequestDocumentKind = {}));
export var ExternalSignRequestDocumentSignatoryStatus;
(function (ExternalSignRequestDocumentSignatoryStatus) {
    ExternalSignRequestDocumentSignatoryStatus["Approved"] = "APPROVED";
    ExternalSignRequestDocumentSignatoryStatus["Opened"] = "OPENED";
    ExternalSignRequestDocumentSignatoryStatus["Preapproved"] = "PREAPPROVED";
    ExternalSignRequestDocumentSignatoryStatus["Rejected"] = "REJECTED";
    ExternalSignRequestDocumentSignatoryStatus["Signed"] = "SIGNED";
})(ExternalSignRequestDocumentSignatoryStatus || (ExternalSignRequestDocumentSignatoryStatus = {}));
export var ExternalSignRequestRejectionReason;
(function (ExternalSignRequestRejectionReason) {
    ExternalSignRequestRejectionReason["Unknown"] = "UNKNOWN";
    ExternalSignRequestRejectionReason["Upstream"] = "UPSTREAM";
    ExternalSignRequestRejectionReason["Validation"] = "VALIDATION";
})(ExternalSignRequestRejectionReason || (ExternalSignRequestRejectionReason = {}));
export var ExternalSignRequestSignatoryStatus;
(function (ExternalSignRequestSignatoryStatus) {
    ExternalSignRequestSignatoryStatus["Deleted"] = "DELETED";
    ExternalSignRequestSignatoryStatus["Error"] = "ERROR";
    ExternalSignRequestSignatoryStatus["Open"] = "OPEN";
    ExternalSignRequestSignatoryStatus["Rejected"] = "REJECTED";
    ExternalSignRequestSignatoryStatus["Signed"] = "SIGNED";
})(ExternalSignRequestSignatoryStatus || (ExternalSignRequestSignatoryStatus = {}));
export var ExternalSignRequestStatus;
(function (ExternalSignRequestStatus) {
    ExternalSignRequestStatus["Cancelled"] = "CANCELLED";
    ExternalSignRequestStatus["Closed"] = "CLOSED";
    ExternalSignRequestStatus["Expired"] = "EXPIRED";
    ExternalSignRequestStatus["Open"] = "OPEN";
})(ExternalSignRequestStatus || (ExternalSignRequestStatus = {}));
export var ExternalStartVerificationInputStage;
(function (ExternalStartVerificationInputStage) {
    ExternalStartVerificationInputStage["Sign"] = "SIGN";
    ExternalStartVerificationInputStage["View"] = "VIEW";
})(ExternalStartVerificationInputStage || (ExternalStartVerificationInputStage = {}));
export var ExternalStartVerificationRejectionReason;
(function (ExternalStartVerificationRejectionReason) {
    ExternalStartVerificationRejectionReason["Unknown"] = "UNKNOWN";
    ExternalStartVerificationRejectionReason["Upstream"] = "UPSTREAM";
    ExternalStartVerificationRejectionReason["Validation"] = "VALIDATION";
})(ExternalStartVerificationRejectionReason || (ExternalStartVerificationRejectionReason = {}));
/** unique or primary key constraints on table "pl.feature" */
export var FeatureConstraint;
(function (FeatureConstraint) {
    /** unique or primary key constraint on columns "id" */
    FeatureConstraint["FeaturePkey"] = "feature_pkey";
})(FeatureConstraint || (FeatureConstraint = {}));
/** unique or primary key constraints on table "pl.feature_metadata" */
export var FeatureMetadataConstraint;
(function (FeatureMetadataConstraint) {
    /** unique or primary key constraint on columns "feature_id", "market_locale_code", "market_code" */
    FeatureMetadataConstraint["FeatureMetadataFeatureIdMarketCodeMarketLocaleCodeKey"] = "feature_metadata_feature_id_market_code_market_locale_code_key";
    /** unique or primary key constraint on columns "id" */
    FeatureMetadataConstraint["FeatureMetadataPkey"] = "feature_metadata_pkey";
})(FeatureMetadataConstraint || (FeatureMetadataConstraint = {}));
/** select columns of table "pl.feature_metadata" */
export var FeatureMetadataSelectColumn;
(function (FeatureMetadataSelectColumn) {
    /** column name */
    FeatureMetadataSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    FeatureMetadataSelectColumn["FeatureId"] = "feature_id";
    /** column name */
    FeatureMetadataSelectColumn["Id"] = "id";
    /** column name */
    FeatureMetadataSelectColumn["MarketCode"] = "market_code";
    /** column name */
    FeatureMetadataSelectColumn["MarketLocaleCode"] = "market_locale_code";
    /** column name */
    FeatureMetadataSelectColumn["Title"] = "title";
    /** column name */
    FeatureMetadataSelectColumn["UpdatedAt"] = "updated_at";
})(FeatureMetadataSelectColumn || (FeatureMetadataSelectColumn = {}));
/** update columns of table "pl.feature_metadata" */
export var FeatureMetadataUpdateColumn;
(function (FeatureMetadataUpdateColumn) {
    /** column name */
    FeatureMetadataUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    FeatureMetadataUpdateColumn["FeatureId"] = "feature_id";
    /** column name */
    FeatureMetadataUpdateColumn["Id"] = "id";
    /** column name */
    FeatureMetadataUpdateColumn["MarketCode"] = "market_code";
    /** column name */
    FeatureMetadataUpdateColumn["MarketLocaleCode"] = "market_locale_code";
    /** column name */
    FeatureMetadataUpdateColumn["Title"] = "title";
    /** column name */
    FeatureMetadataUpdateColumn["UpdatedAt"] = "updated_at";
})(FeatureMetadataUpdateColumn || (FeatureMetadataUpdateColumn = {}));
/** select columns of table "pl.feature" */
export var FeatureSelectColumn;
(function (FeatureSelectColumn) {
    /** column name */
    FeatureSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    FeatureSelectColumn["Data"] = "data";
    /** column name */
    FeatureSelectColumn["Id"] = "id";
    /** column name */
    FeatureSelectColumn["UpdatedAt"] = "updated_at";
})(FeatureSelectColumn || (FeatureSelectColumn = {}));
/** update columns of table "pl.feature" */
export var FeatureUpdateColumn;
(function (FeatureUpdateColumn) {
    /** column name */
    FeatureUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    FeatureUpdateColumn["Data"] = "data";
    /** column name */
    FeatureUpdateColumn["Id"] = "id";
    /** column name */
    FeatureUpdateColumn["UpdatedAt"] = "updated_at";
})(FeatureUpdateColumn || (FeatureUpdateColumn = {}));
export var FileSystemActivityActorType;
(function (FileSystemActivityActorType) {
    FileSystemActivityActorType["System"] = "System";
    FileSystemActivityActorType["Unknown"] = "Unknown";
    FileSystemActivityActorType["User"] = "User";
})(FileSystemActivityActorType || (FileSystemActivityActorType = {}));
export var FileSystemActivityCategory;
(function (FileSystemActivityCategory) {
    FileSystemActivityCategory["Project"] = "Project";
    FileSystemActivityCategory["Unknown"] = "Unknown";
})(FileSystemActivityCategory || (FileSystemActivityCategory = {}));
export var FileSystemActivityType;
(function (FileSystemActivityType) {
    FileSystemActivityType["ProjectCreated"] = "ProjectCreated";
    FileSystemActivityType["ProjectDeleted"] = "ProjectDeleted";
    FileSystemActivityType["ProjectDocumentsAdded"] = "ProjectDocumentsAdded";
    FileSystemActivityType["ProjectDocumentsPermissionsChanged"] = "ProjectDocumentsPermissionsChanged";
    FileSystemActivityType["ProjectDocumentsRemoved"] = "ProjectDocumentsRemoved";
    FileSystemActivityType["ProjectNodesAdded"] = "ProjectNodesAdded";
    FileSystemActivityType["ProjectNodesRemoved"] = "ProjectNodesRemoved";
    FileSystemActivityType["ProjectNodesUpdated"] = "ProjectNodesUpdated";
    FileSystemActivityType["ProjectTeamsAdded"] = "ProjectTeamsAdded";
    FileSystemActivityType["ProjectTeamsRemoved"] = "ProjectTeamsRemoved";
    FileSystemActivityType["ProjectUpdated"] = "ProjectUpdated";
    FileSystemActivityType["ProjectUsersAdded"] = "ProjectUsersAdded";
    FileSystemActivityType["ProjectUsersRemoved"] = "ProjectUsersRemoved";
    FileSystemActivityType["Unknown"] = "Unknown";
})(FileSystemActivityType || (FileSystemActivityType = {}));
export var FileSystemDocumentDownloadFormat;
(function (FileSystemDocumentDownloadFormat) {
    FileSystemDocumentDownloadFormat["Pdf"] = "PDF";
})(FileSystemDocumentDownloadFormat || (FileSystemDocumentDownloadFormat = {}));
export var FileSystemDocumentStatus;
(function (FileSystemDocumentStatus) {
    FileSystemDocumentStatus["AgreedStage"] = "AGREED_STAGE";
    FileSystemDocumentStatus["AgreedStageAgreedForm"] = "AGREED_STAGE__AGREED_FORM";
    FileSystemDocumentStatus["DraftStage"] = "DRAFT_STAGE";
    FileSystemDocumentStatus["Inconsistent"] = "INCONSISTENT";
    FileSystemDocumentStatus["ReviewStage"] = "REVIEW_STAGE";
    FileSystemDocumentStatus["ReviewStageApproved"] = "REVIEW_STAGE__APPROVED";
    FileSystemDocumentStatus["ReviewStageCancelled"] = "REVIEW_STAGE__CANCELLED";
    FileSystemDocumentStatus["ReviewStagePending"] = "REVIEW_STAGE__PENDING";
    FileSystemDocumentStatus["ReviewStageRejected"] = "REVIEW_STAGE__REJECTED";
    FileSystemDocumentStatus["SigningStage"] = "SIGNING_STAGE";
    FileSystemDocumentStatus["SigningStageCancelled"] = "SIGNING_STAGE__CANCELLED";
    FileSystemDocumentStatus["SigningStageFailed"] = "SIGNING_STAGE__FAILED";
    FileSystemDocumentStatus["SigningStagePending"] = "SIGNING_STAGE__PENDING";
    FileSystemDocumentStatus["SigningStagePendingNotYetSigned"] = "SIGNING_STAGE__PENDING__NOT_YET_SIGNED";
    FileSystemDocumentStatus["SigningStagePendingPartiallySigned"] = "SIGNING_STAGE__PENDING__PARTIALLY_SIGNED";
    FileSystemDocumentStatus["SigningStageRejected"] = "SIGNING_STAGE__REJECTED";
    FileSystemDocumentStatus["SigningStageSigned"] = "SIGNING_STAGE__SIGNED";
    FileSystemDocumentStatus["Unknown"] = "UNKNOWN";
})(FileSystemDocumentStatus || (FileSystemDocumentStatus = {}));
export var FileSystemDocumentStatusExplicitEvents;
(function (FileSystemDocumentStatusExplicitEvents) {
    FileSystemDocumentStatusExplicitEvents["ExplicitlySetAgreed"] = "EXPLICITLY_SET_AGREED";
    FileSystemDocumentStatusExplicitEvents["ExplicitlySetDraft"] = "EXPLICITLY_SET_DRAFT";
    FileSystemDocumentStatusExplicitEvents["ExplicitlySetSigned"] = "EXPLICITLY_SET_SIGNED";
})(FileSystemDocumentStatusExplicitEvents || (FileSystemDocumentStatusExplicitEvents = {}));
export var FileSystemDocumentSuggestionStatus;
(function (FileSystemDocumentSuggestionStatus) {
    FileSystemDocumentSuggestionStatus["Accepted"] = "accepted";
    FileSystemDocumentSuggestionStatus["Open"] = "open";
    FileSystemDocumentSuggestionStatus["Rejected"] = "rejected";
})(FileSystemDocumentSuggestionStatus || (FileSystemDocumentSuggestionStatus = {}));
export var FileSystemDocumentSuggestionType;
(function (FileSystemDocumentSuggestionType) {
    FileSystemDocumentSuggestionType["Deletion"] = "deletion";
    FileSystemDocumentSuggestionType["FormatBlock"] = "formatBlock";
    FileSystemDocumentSuggestionType["FormatInline"] = "formatInline";
    FileSystemDocumentSuggestionType["Insertion"] = "insertion";
})(FileSystemDocumentSuggestionType || (FileSystemDocumentSuggestionType = {}));
export var FileSystemFeature;
(function (FileSystemFeature) {
    FileSystemFeature["ImportExport"] = "IMPORT_EXPORT";
    FileSystemFeature["Projects"] = "PROJECTS";
    FileSystemFeature["Rtc"] = "RTC";
    FileSystemFeature["Suggestions"] = "SUGGESTIONS";
})(FileSystemFeature || (FileSystemFeature = {}));
export var FileSystemProjectContractTerm;
(function (FileSystemProjectContractTerm) {
    FileSystemProjectContractTerm["NotStarted"] = "NOT_STARTED";
    FileSystemProjectContractTerm["Ongoing"] = "ONGOING";
    FileSystemProjectContractTerm["Terminated"] = "TERMINATED";
})(FileSystemProjectContractTerm || (FileSystemProjectContractTerm = {}));
export var FileSystemProjectMetadataPropertyUiWidgetHintEnum;
(function (FileSystemProjectMetadataPropertyUiWidgetHintEnum) {
    FileSystemProjectMetadataPropertyUiWidgetHintEnum["DatePicker"] = "DatePicker";
    FileSystemProjectMetadataPropertyUiWidgetHintEnum["DateTimePicker"] = "DateTimePicker";
    FileSystemProjectMetadataPropertyUiWidgetHintEnum["InputNumber"] = "InputNumber";
    FileSystemProjectMetadataPropertyUiWidgetHintEnum["InputText"] = "InputText";
    FileSystemProjectMetadataPropertyUiWidgetHintEnum["Select"] = "Select";
    FileSystemProjectMetadataPropertyUiWidgetHintEnum["SelectWithInput"] = "SelectWithInput";
    FileSystemProjectMetadataPropertyUiWidgetHintEnum["Switch"] = "Switch";
    FileSystemProjectMetadataPropertyUiWidgetHintEnum["TextArea"] = "TextArea";
})(FileSystemProjectMetadataPropertyUiWidgetHintEnum || (FileSystemProjectMetadataPropertyUiWidgetHintEnum = {}));
export var FileSystemProjectNodesRelationType;
(function (FileSystemProjectNodesRelationType) {
    FileSystemProjectNodesRelationType["AmendedBy"] = "AMENDED_BY";
    FileSystemProjectNodesRelationType["Regular"] = "REGULAR";
    FileSystemProjectNodesRelationType["RenewedBy"] = "RENEWED_BY";
    FileSystemProjectNodesRelationType["ReplacedBy"] = "REPLACED_BY";
    FileSystemProjectNodesRelationType["SupplementedBy"] = "SUPPLEMENTED_BY";
    FileSystemProjectNodesRelationType["TerminatedBy"] = "TERMINATED_BY";
})(FileSystemProjectNodesRelationType || (FileSystemProjectNodesRelationType = {}));
export var FileSystemProjectStatus;
(function (FileSystemProjectStatus) {
    FileSystemProjectStatus["Backlog"] = "BACKLOG";
    FileSystemProjectStatus["Cancelled"] = "CANCELLED";
    FileSystemProjectStatus["Completed"] = "COMPLETED";
    FileSystemProjectStatus["InProgress"] = "IN_PROGRESS";
    FileSystemProjectStatus["OnHold"] = "ON_HOLD";
})(FileSystemProjectStatus || (FileSystemProjectStatus = {}));
export var FolderUploadJobStatus;
(function (FolderUploadJobStatus) {
    FolderUploadJobStatus["Done"] = "DONE";
    FolderUploadJobStatus["Failed"] = "FAILED";
    FolderUploadJobStatus["Pending"] = "PENDING";
    FolderUploadJobStatus["Processing"] = "PROCESSING";
})(FolderUploadJobStatus || (FolderUploadJobStatus = {}));
export var GlobalAssistantChatMessageRole;
(function (GlobalAssistantChatMessageRole) {
    GlobalAssistantChatMessageRole["Assistant"] = "ASSISTANT";
    GlobalAssistantChatMessageRole["Tool"] = "TOOL";
    GlobalAssistantChatMessageRole["User"] = "USER";
})(GlobalAssistantChatMessageRole || (GlobalAssistantChatMessageRole = {}));
export var GlobalAssistantChatMessageStatus;
(function (GlobalAssistantChatMessageStatus) {
    GlobalAssistantChatMessageStatus["Failed"] = "FAILED";
    GlobalAssistantChatMessageStatus["Heartbeat"] = "HEARTBEAT";
    GlobalAssistantChatMessageStatus["Pending"] = "PENDING";
    GlobalAssistantChatMessageStatus["Resolved"] = "RESOLVED";
})(GlobalAssistantChatMessageStatus || (GlobalAssistantChatMessageStatus = {}));
export var GlobalAssistantChatMessageType;
(function (GlobalAssistantChatMessageType) {
    GlobalAssistantChatMessageType["Chronology"] = "CHRONOLOGY";
    GlobalAssistantChatMessageType["Draft"] = "DRAFT";
    GlobalAssistantChatMessageType["ExtractMetadata"] = "EXTRACT_METADATA";
    GlobalAssistantChatMessageType["FigureItOut"] = "FIGURE_IT_OUT";
    GlobalAssistantChatMessageType["FullContextQuestion"] = "FULL_CONTEXT_QUESTION";
    GlobalAssistantChatMessageType["GeneralQuestion"] = "GENERAL_QUESTION";
    GlobalAssistantChatMessageType["QueryExpansion"] = "QUERY_EXPANSION";
    GlobalAssistantChatMessageType["SearchOptimization"] = "SEARCH_OPTIMIZATION";
    GlobalAssistantChatMessageType["Summary"] = "SUMMARY";
})(GlobalAssistantChatMessageType || (GlobalAssistantChatMessageType = {}));
export var ImportDocumentToCcsStatus;
(function (ImportDocumentToCcsStatus) {
    ImportDocumentToCcsStatus["Done"] = "DONE";
    ImportDocumentToCcsStatus["Failed"] = "FAILED";
    ImportDocumentToCcsStatus["Pending"] = "PENDING";
    ImportDocumentToCcsStatus["Processing"] = "PROCESSING";
})(ImportDocumentToCcsStatus || (ImportDocumentToCcsStatus = {}));
/** https://stripe.com/docs/api/invoices/object#invoice_object-status */
export var InvoiceStatusEnum;
(function (InvoiceStatusEnum) {
    InvoiceStatusEnum["Draft"] = "DRAFT";
    InvoiceStatusEnum["Open"] = "OPEN";
    InvoiceStatusEnum["Paid"] = "PAID";
    InvoiceStatusEnum["Uncollectible"] = "UNCOLLECTIBLE";
    InvoiceStatusEnum["Void"] = "VOID";
})(InvoiceStatusEnum || (InvoiceStatusEnum = {}));
/** unique or primary key constraints on table "pl.market" */
export var MarketConstraint;
(function (MarketConstraint) {
    /** unique or primary key constraint on columns "id" */
    MarketConstraint["MarketIdKey"] = "market_id_key";
    /** unique or primary key constraint on columns "code" */
    MarketConstraint["MarketPkey"] = "market_pkey";
})(MarketConstraint || (MarketConstraint = {}));
/** unique or primary key constraints on table "pl.market_feature" */
export var MarketFeatureConstraint;
(function (MarketFeatureConstraint) {
    /** unique or primary key constraint on columns "feature_id", "market_code" */
    MarketFeatureConstraint["MarketFeatureMarketCodeFeatureIdKey"] = "market_feature_market_code_feature_id_key";
    /** unique or primary key constraint on columns "id" */
    MarketFeatureConstraint["MarketFeaturePkey"] = "market_feature_pkey";
})(MarketFeatureConstraint || (MarketFeatureConstraint = {}));
/** select columns of table "pl.market_feature" */
export var MarketFeatureSelectColumn;
(function (MarketFeatureSelectColumn) {
    /** column name */
    MarketFeatureSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    MarketFeatureSelectColumn["FeatureId"] = "feature_id";
    /** column name */
    MarketFeatureSelectColumn["Id"] = "id";
    /** column name */
    MarketFeatureSelectColumn["MarketCode"] = "market_code";
    /** column name */
    MarketFeatureSelectColumn["Ordinal"] = "ordinal";
    /** column name */
    MarketFeatureSelectColumn["SalesPromoted"] = "sales_promoted";
    /** column name */
    MarketFeatureSelectColumn["UpdatedAt"] = "updated_at";
})(MarketFeatureSelectColumn || (MarketFeatureSelectColumn = {}));
/** update columns of table "pl.market_feature" */
export var MarketFeatureUpdateColumn;
(function (MarketFeatureUpdateColumn) {
    /** column name */
    MarketFeatureUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    MarketFeatureUpdateColumn["FeatureId"] = "feature_id";
    /** column name */
    MarketFeatureUpdateColumn["Id"] = "id";
    /** column name */
    MarketFeatureUpdateColumn["MarketCode"] = "market_code";
    /** column name */
    MarketFeatureUpdateColumn["Ordinal"] = "ordinal";
    /** column name */
    MarketFeatureUpdateColumn["SalesPromoted"] = "sales_promoted";
    /** column name */
    MarketFeatureUpdateColumn["UpdatedAt"] = "updated_at";
})(MarketFeatureUpdateColumn || (MarketFeatureUpdateColumn = {}));
/** unique or primary key constraints on table "pl.market_locale" */
export var MarketLocaleConstraint;
(function (MarketLocaleConstraint) {
    /** unique or primary key constraint on columns "code", "market_code" */
    MarketLocaleConstraint["MarketLocalePkey"] = "market_locale_pkey";
})(MarketLocaleConstraint || (MarketLocaleConstraint = {}));
/** select columns of table "pl.market_locale" */
export var MarketLocaleSelectColumn;
(function (MarketLocaleSelectColumn) {
    /** column name */
    MarketLocaleSelectColumn["Code"] = "code";
    /** column name */
    MarketLocaleSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    MarketLocaleSelectColumn["Id"] = "id";
    /** column name */
    MarketLocaleSelectColumn["MarketCode"] = "market_code";
    /** column name */
    MarketLocaleSelectColumn["MarketId"] = "market_id";
    /** column name */
    MarketLocaleSelectColumn["UpdatedAt"] = "updated_at";
})(MarketLocaleSelectColumn || (MarketLocaleSelectColumn = {}));
/** update columns of table "pl.market_locale" */
export var MarketLocaleUpdateColumn;
(function (MarketLocaleUpdateColumn) {
    /** column name */
    MarketLocaleUpdateColumn["Code"] = "code";
    /** column name */
    MarketLocaleUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    MarketLocaleUpdateColumn["Id"] = "id";
    /** column name */
    MarketLocaleUpdateColumn["MarketCode"] = "market_code";
    /** column name */
    MarketLocaleUpdateColumn["MarketId"] = "market_id";
    /** column name */
    MarketLocaleUpdateColumn["UpdatedAt"] = "updated_at";
})(MarketLocaleUpdateColumn || (MarketLocaleUpdateColumn = {}));
/** select columns of table "pl.market" */
export var MarketSelectColumn;
(function (MarketSelectColumn) {
    /** column name */
    MarketSelectColumn["Code"] = "code";
    /** column name */
    MarketSelectColumn["CodeIso"] = "code_iso";
    /** column name */
    MarketSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    MarketSelectColumn["Id"] = "id";
    /** column name */
    MarketSelectColumn["Name"] = "name";
    /** column name */
    MarketSelectColumn["StripePublicKey"] = "stripe_public_key";
    /** column name */
    MarketSelectColumn["StripeTaxRateId"] = "stripe_tax_rate_id";
    /** column name */
    MarketSelectColumn["UpdatedAt"] = "updated_at";
})(MarketSelectColumn || (MarketSelectColumn = {}));
/** update columns of table "pl.market" */
export var MarketUpdateColumn;
(function (MarketUpdateColumn) {
    /** column name */
    MarketUpdateColumn["Code"] = "code";
    /** column name */
    MarketUpdateColumn["CodeIso"] = "code_iso";
    /** column name */
    MarketUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    MarketUpdateColumn["Id"] = "id";
    /** column name */
    MarketUpdateColumn["Name"] = "name";
    /** column name */
    MarketUpdateColumn["StripePublicKey"] = "stripe_public_key";
    /** column name */
    MarketUpdateColumn["StripeTaxRateId"] = "stripe_tax_rate_id";
    /** column name */
    MarketUpdateColumn["UpdatedAt"] = "updated_at";
})(MarketUpdateColumn || (MarketUpdateColumn = {}));
/** column ordering options */
export var OrderBy;
(function (OrderBy) {
    /** in ascending order, nulls last */
    OrderBy["Asc"] = "asc";
    /** in ascending order, nulls first */
    OrderBy["AscNullsFirst"] = "asc_nulls_first";
    /** in ascending order, nulls last */
    OrderBy["AscNullsLast"] = "asc_nulls_last";
    /** in descending order, nulls first */
    OrderBy["Desc"] = "desc";
    /** in descending order, nulls first */
    OrderBy["DescNullsFirst"] = "desc_nulls_first";
    /** in descending order, nulls last */
    OrderBy["DescNullsLast"] = "desc_nulls_last";
})(OrderBy || (OrderBy = {}));
export var OrderByArg;
(function (OrderByArg) {
    OrderByArg["Asc"] = "asc";
    OrderByArg["Desc"] = "desc";
})(OrderByArg || (OrderByArg = {}));
export var PartialCompanyUserRoleEnum;
(function (PartialCompanyUserRoleEnum) {
    PartialCompanyUserRoleEnum["Member"] = "member";
    PartialCompanyUserRoleEnum["Owner"] = "owner";
})(PartialCompanyUserRoleEnum || (PartialCompanyUserRoleEnum = {}));
/** https://stripe.com/docs/error-codes */
export var PaymentErrorCodeEnum;
(function (PaymentErrorCodeEnum) {
    /** https://stripe.com/docs/error-codes#card-declined */
    PaymentErrorCodeEnum["CardDeclined"] = "CARD_DECLINED";
    /** https://stripe.com/docs/error-codes#resource-missing */
    PaymentErrorCodeEnum["ResourceMissing"] = "RESOURCE_MISSING";
})(PaymentErrorCodeEnum || (PaymentErrorCodeEnum = {}));
/** https://stripe.com/docs/api/payment_intents/object#payment_intent_object-status */
export var PaymentIntentStatusEnum;
(function (PaymentIntentStatusEnum) {
    PaymentIntentStatusEnum["Canceled"] = "CANCELED";
    PaymentIntentStatusEnum["Processing"] = "PROCESSING";
    PaymentIntentStatusEnum["RequiresAction"] = "REQUIRES_ACTION";
    PaymentIntentStatusEnum["RequiresCapture"] = "REQUIRES_CAPTURE";
    PaymentIntentStatusEnum["RequiresConfirmation"] = "REQUIRES_CONFIRMATION";
    PaymentIntentStatusEnum["RequiresPaymentMethod"] = "REQUIRES_PAYMENT_METHOD";
    PaymentIntentStatusEnum["Succeeded"] = "SUCCEEDED";
})(PaymentIntentStatusEnum || (PaymentIntentStatusEnum = {}));
/** https://stripe.com/docs/api/subscriptions/object#subscription_object-collection_method */
export var PaymentSubscriptionCollectionMethodEnum;
(function (PaymentSubscriptionCollectionMethodEnum) {
    PaymentSubscriptionCollectionMethodEnum["ChargeAutomatically"] = "CHARGE_AUTOMATICALLY";
    PaymentSubscriptionCollectionMethodEnum["SendInvoice"] = "SEND_INVOICE";
})(PaymentSubscriptionCollectionMethodEnum || (PaymentSubscriptionCollectionMethodEnum = {}));
/** https://stripe.com/docs/api/subscriptions/object#subscription_object-status */
export var PaymentSubscriptionStatusEnum;
(function (PaymentSubscriptionStatusEnum) {
    PaymentSubscriptionStatusEnum["Active"] = "ACTIVE";
    PaymentSubscriptionStatusEnum["Canceled"] = "CANCELED";
    PaymentSubscriptionStatusEnum["Incomplete"] = "INCOMPLETE";
    PaymentSubscriptionStatusEnum["IncompleteExpired"] = "INCOMPLETE_EXPIRED";
    PaymentSubscriptionStatusEnum["PastDue"] = "PAST_DUE";
    PaymentSubscriptionStatusEnum["Traling"] = "TRALING";
    PaymentSubscriptionStatusEnum["Unpaid"] = "UNPAID";
})(PaymentSubscriptionStatusEnum || (PaymentSubscriptionStatusEnum = {}));
/** unique or primary key constraints on table "pl.plan" */
export var PlanConstraint;
(function (PlanConstraint) {
    /** unique or primary key constraint on columns "id" */
    PlanConstraint["PlanPkey"] = "plan_pkey";
})(PlanConstraint || (PlanConstraint = {}));
/** unique or primary key constraints on table "pl.plan_feature" */
export var PlanFeatureConstraint;
(function (PlanFeatureConstraint) {
    /** unique or primary key constraint on columns "id" */
    PlanFeatureConstraint["PlanFeaturePkey"] = "plan_feature_pkey";
    /** unique or primary key constraint on columns "feature_id", "plan_id" */
    PlanFeatureConstraint["PlanFeaturePlanIdFeatureIdKey"] = "plan_feature_plan_id_feature_id_key";
})(PlanFeatureConstraint || (PlanFeatureConstraint = {}));
/** select columns of table "pl.plan_feature" */
export var PlanFeatureSelectColumn;
(function (PlanFeatureSelectColumn) {
    /** column name */
    PlanFeatureSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    PlanFeatureSelectColumn["FeatureId"] = "feature_id";
    /** column name */
    PlanFeatureSelectColumn["Id"] = "id";
    /** column name */
    PlanFeatureSelectColumn["PlanId"] = "plan_id";
    /** column name */
    PlanFeatureSelectColumn["UpdatedAt"] = "updated_at";
})(PlanFeatureSelectColumn || (PlanFeatureSelectColumn = {}));
/** update columns of table "pl.plan_feature" */
export var PlanFeatureUpdateColumn;
(function (PlanFeatureUpdateColumn) {
    /** column name */
    PlanFeatureUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    PlanFeatureUpdateColumn["FeatureId"] = "feature_id";
    /** column name */
    PlanFeatureUpdateColumn["Id"] = "id";
    /** column name */
    PlanFeatureUpdateColumn["PlanId"] = "plan_id";
    /** column name */
    PlanFeatureUpdateColumn["UpdatedAt"] = "updated_at";
})(PlanFeatureUpdateColumn || (PlanFeatureUpdateColumn = {}));
/** unique or primary key constraints on table "pl.plan_metadata" */
export var PlanMetadataConstraint;
(function (PlanMetadataConstraint) {
    /** unique or primary key constraint on columns "id" */
    PlanMetadataConstraint["PlanMetadataPkey"] = "plan_metadata_pkey";
    /** unique or primary key constraint on columns "market_locale_code", "plan_id" */
    PlanMetadataConstraint["PlanMetadataPlanIdMarketLocaleCodeKey"] = "plan_metadata_plan_id_market_locale_code_key";
})(PlanMetadataConstraint || (PlanMetadataConstraint = {}));
/** select columns of table "pl.plan_metadata" */
export var PlanMetadataSelectColumn;
(function (PlanMetadataSelectColumn) {
    /** column name */
    PlanMetadataSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    PlanMetadataSelectColumn["Description"] = "description";
    /** column name */
    PlanMetadataSelectColumn["Id"] = "id";
    /** column name */
    PlanMetadataSelectColumn["MarketCode"] = "market_code";
    /** column name */
    PlanMetadataSelectColumn["MarketLocaleCode"] = "market_locale_code";
    /** column name */
    PlanMetadataSelectColumn["PlanId"] = "plan_id";
    /** column name */
    PlanMetadataSelectColumn["UpdatedAt"] = "updated_at";
})(PlanMetadataSelectColumn || (PlanMetadataSelectColumn = {}));
/** update columns of table "pl.plan_metadata" */
export var PlanMetadataUpdateColumn;
(function (PlanMetadataUpdateColumn) {
    /** column name */
    PlanMetadataUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    PlanMetadataUpdateColumn["Description"] = "description";
    /** column name */
    PlanMetadataUpdateColumn["Id"] = "id";
    /** column name */
    PlanMetadataUpdateColumn["MarketCode"] = "market_code";
    /** column name */
    PlanMetadataUpdateColumn["MarketLocaleCode"] = "market_locale_code";
    /** column name */
    PlanMetadataUpdateColumn["PlanId"] = "plan_id";
    /** column name */
    PlanMetadataUpdateColumn["UpdatedAt"] = "updated_at";
})(PlanMetadataUpdateColumn || (PlanMetadataUpdateColumn = {}));
/** select columns of table "pl.plan" */
export var PlanSelectColumn;
(function (PlanSelectColumn) {
    /** column name */
    PlanSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    PlanSelectColumn["Enabled"] = "enabled";
    /** column name */
    PlanSelectColumn["Features"] = "features";
    /** column name */
    PlanSelectColumn["Id"] = "id";
    /** column name */
    PlanSelectColumn["MarketCode"] = "market_code";
    /** column name */
    PlanSelectColumn["Name"] = "name";
    /** column name */
    PlanSelectColumn["Ordinal"] = "ordinal";
    /** column name */
    PlanSelectColumn["StripeProductId"] = "stripe_product_id";
    /** column name */
    PlanSelectColumn["Title"] = "title";
    /** column name */
    PlanSelectColumn["Type"] = "type";
    /** column name */
    PlanSelectColumn["UpdatedAt"] = "updated_at";
})(PlanSelectColumn || (PlanSelectColumn = {}));
/** unique or primary key constraints on table "pl.plan_type_enum" */
export var PlanTypeEnumConstraint;
(function (PlanTypeEnumConstraint) {
    /** unique or primary key constraint on columns "name" */
    PlanTypeEnumConstraint["PlanTypeEnumPkey"] = "plan_type_enum_pkey";
})(PlanTypeEnumConstraint || (PlanTypeEnumConstraint = {}));
export var PlanTypeEnumEnum;
(function (PlanTypeEnumEnum) {
    /** big plan with monthly payment */
    PlanTypeEnumEnum["Big"] = "big";
    /** free plan */
    PlanTypeEnumEnum["Free"] = "free";
    /** medium plan with monthly payment */
    PlanTypeEnumEnum["Medium"] = "medium";
    /** small plan with yearly payment */
    PlanTypeEnumEnum["Small"] = "small";
    /** smallplus plan with monthly payment */
    PlanTypeEnumEnum["Smallplus"] = "smallplus";
    /** trial period */
    PlanTypeEnumEnum["Trial"] = "trial";
})(PlanTypeEnumEnum || (PlanTypeEnumEnum = {}));
/** select columns of table "pl.plan_type_enum" */
export var PlanTypeEnumSelectColumn;
(function (PlanTypeEnumSelectColumn) {
    /** column name */
    PlanTypeEnumSelectColumn["Description"] = "description";
    /** column name */
    PlanTypeEnumSelectColumn["Name"] = "name";
})(PlanTypeEnumSelectColumn || (PlanTypeEnumSelectColumn = {}));
/** update columns of table "pl.plan_type_enum" */
export var PlanTypeEnumUpdateColumn;
(function (PlanTypeEnumUpdateColumn) {
    /** column name */
    PlanTypeEnumUpdateColumn["Description"] = "description";
    /** column name */
    PlanTypeEnumUpdateColumn["Name"] = "name";
})(PlanTypeEnumUpdateColumn || (PlanTypeEnumUpdateColumn = {}));
/** update columns of table "pl.plan" */
export var PlanUpdateColumn;
(function (PlanUpdateColumn) {
    /** column name */
    PlanUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    PlanUpdateColumn["Enabled"] = "enabled";
    /** column name */
    PlanUpdateColumn["Features"] = "features";
    /** column name */
    PlanUpdateColumn["Id"] = "id";
    /** column name */
    PlanUpdateColumn["MarketCode"] = "market_code";
    /** column name */
    PlanUpdateColumn["Name"] = "name";
    /** column name */
    PlanUpdateColumn["Ordinal"] = "ordinal";
    /** column name */
    PlanUpdateColumn["StripeProductId"] = "stripe_product_id";
    /** column name */
    PlanUpdateColumn["Title"] = "title";
    /** column name */
    PlanUpdateColumn["Type"] = "type";
    /** column name */
    PlanUpdateColumn["UpdatedAt"] = "updated_at";
})(PlanUpdateColumn || (PlanUpdateColumn = {}));
/** https://stripe.com/docs/api/prices/object#price_object-recurring-interval */
export var PriceReccuringIntervalEnum;
(function (PriceReccuringIntervalEnum) {
    PriceReccuringIntervalEnum["Day"] = "DAY";
    PriceReccuringIntervalEnum["Month"] = "MONTH";
    PriceReccuringIntervalEnum["Week"] = "WEEK";
    PriceReccuringIntervalEnum["Year"] = "YEAR";
})(PriceReccuringIntervalEnum || (PriceReccuringIntervalEnum = {}));
/** The type of entity referenced in a prompt */
export var PromptEntityReferenceType;
(function (PromptEntityReferenceType) {
    PromptEntityReferenceType["Contact"] = "CONTACT";
    PromptEntityReferenceType["Team"] = "TEAM";
    PromptEntityReferenceType["User"] = "USER";
})(PromptEntityReferenceType || (PromptEntityReferenceType = {}));
/** unique or primary key constraints on table "pl.reminder" */
export var ReminderConstraint;
(function (ReminderConstraint) {
    /** unique or primary key constraint on columns "id" */
    ReminderConstraint["ReminderPkey"] = "reminder_pkey";
})(ReminderConstraint || (ReminderConstraint = {}));
/** unique or primary key constraints on table "pl.reminder_interval" */
export var ReminderIntervalConstraint;
(function (ReminderIntervalConstraint) {
    /** unique or primary key constraint on columns "value" */
    ReminderIntervalConstraint["ReminderIntervalPkey"] = "reminder_interval_pkey";
})(ReminderIntervalConstraint || (ReminderIntervalConstraint = {}));
export var ReminderIntervalEnum;
(function (ReminderIntervalEnum) {
    /** Daily */
    ReminderIntervalEnum["Daily"] = "DAILY";
    /** Every 4th month */
    ReminderIntervalEnum["EveryFourthMonth"] = "EVERY_FOURTH_MONTH";
    /** Every 2nd month */
    ReminderIntervalEnum["EverySecondMonth"] = "EVERY_SECOND_MONTH";
    /** Every 2nd week */
    ReminderIntervalEnum["EverySecondWeek"] = "EVERY_SECOND_WEEK";
    /** Every 6th month */
    ReminderIntervalEnum["EverySixthMonth"] = "EVERY_SIXTH_MONTH";
    /** Monthly */
    ReminderIntervalEnum["Monthly"] = "MONTHLY";
    /** Weekly */
    ReminderIntervalEnum["Weekly"] = "WEEKLY";
    /** Yearly */
    ReminderIntervalEnum["Yearly"] = "YEARLY";
})(ReminderIntervalEnum || (ReminderIntervalEnum = {}));
/** select columns of table "pl.reminder_interval" */
export var ReminderIntervalSelectColumn;
(function (ReminderIntervalSelectColumn) {
    /** column name */
    ReminderIntervalSelectColumn["Description"] = "description";
    /** column name */
    ReminderIntervalSelectColumn["Value"] = "value";
})(ReminderIntervalSelectColumn || (ReminderIntervalSelectColumn = {}));
/** update columns of table "pl.reminder_interval" */
export var ReminderIntervalUpdateColumn;
(function (ReminderIntervalUpdateColumn) {
    /** column name */
    ReminderIntervalUpdateColumn["Description"] = "description";
    /** column name */
    ReminderIntervalUpdateColumn["Value"] = "value";
})(ReminderIntervalUpdateColumn || (ReminderIntervalUpdateColumn = {}));
/** select columns of table "pl.reminder" */
export var ReminderSelectColumn;
(function (ReminderSelectColumn) {
    /** column name */
    ReminderSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    ReminderSelectColumn["DueDate"] = "due_date";
    /** column name */
    ReminderSelectColumn["Id"] = "id";
    /** column name */
    ReminderSelectColumn["Interval"] = "interval";
    /** column name */
    ReminderSelectColumn["RecipientEmail"] = "recipient_email";
    /** column name */
    ReminderSelectColumn["TaskId"] = "task_id";
    /** column name */
    ReminderSelectColumn["UpdatedAt"] = "updated_at";
})(ReminderSelectColumn || (ReminderSelectColumn = {}));
/** update columns of table "pl.reminder" */
export var ReminderUpdateColumn;
(function (ReminderUpdateColumn) {
    /** column name */
    ReminderUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    ReminderUpdateColumn["DueDate"] = "due_date";
    /** column name */
    ReminderUpdateColumn["Id"] = "id";
    /** column name */
    ReminderUpdateColumn["Interval"] = "interval";
    /** column name */
    ReminderUpdateColumn["RecipientEmail"] = "recipient_email";
    /** column name */
    ReminderUpdateColumn["TaskId"] = "task_id";
    /** column name */
    ReminderUpdateColumn["UpdatedAt"] = "updated_at";
})(ReminderUpdateColumn || (ReminderUpdateColumn = {}));
export var RemoveEsigningRecipientRejectionReason;
(function (RemoveEsigningRecipientRejectionReason) {
    RemoveEsigningRecipientRejectionReason["ActiveSignRequest"] = "ACTIVE_SIGN_REQUEST";
    RemoveEsigningRecipientRejectionReason["AlreadySigned"] = "ALREADY_SIGNED";
    RemoveEsigningRecipientRejectionReason["MustHaveAtLeastOneSignatory"] = "MUST_HAVE_AT_LEAST_ONE_SIGNATORY";
    RemoveEsigningRecipientRejectionReason["NotAuthorized"] = "NOT_AUTHORIZED";
    RemoveEsigningRecipientRejectionReason["NotConnectedToEsigningProvider"] = "NOT_CONNECTED_TO_ESIGNING_PROVIDER";
    RemoveEsigningRecipientRejectionReason["NotFound"] = "NOT_FOUND";
    RemoveEsigningRecipientRejectionReason["NotSupported"] = "NOT_SUPPORTED";
    RemoveEsigningRecipientRejectionReason["PendingSignRequest"] = "PENDING_SIGN_REQUEST";
    RemoveEsigningRecipientRejectionReason["ProviderRequestFailed"] = "PROVIDER_REQUEST_FAILED";
})(RemoveEsigningRecipientRejectionReason || (RemoveEsigningRecipientRejectionReason = {}));
export var SearchAggregationDateInterval;
(function (SearchAggregationDateInterval) {
    SearchAggregationDateInterval["Day"] = "day";
    SearchAggregationDateInterval["Month"] = "month";
    SearchAggregationDateInterval["Quarter"] = "quarter";
    SearchAggregationDateInterval["Week"] = "week";
    SearchAggregationDateInterval["Year"] = "year";
})(SearchAggregationDateInterval || (SearchAggregationDateInterval = {}));
export var SearchAggregationMetricType;
(function (SearchAggregationMetricType) {
    SearchAggregationMetricType["Avg"] = "avg";
    SearchAggregationMetricType["Cardinality"] = "cardinality";
    SearchAggregationMetricType["Max"] = "max";
    SearchAggregationMetricType["Min"] = "min";
    SearchAggregationMetricType["Sum"] = "sum";
    SearchAggregationMetricType["ValueCount"] = "value_count";
})(SearchAggregationMetricType || (SearchAggregationMetricType = {}));
export var SearchAggregationTimeUnit;
(function (SearchAggregationTimeUnit) {
    SearchAggregationTimeUnit["Day"] = "day";
    SearchAggregationTimeUnit["Month"] = "month";
    SearchAggregationTimeUnit["Week"] = "week";
    SearchAggregationTimeUnit["Year"] = "year";
})(SearchAggregationTimeUnit || (SearchAggregationTimeUnit = {}));
export var SearchAggregationType;
(function (SearchAggregationType) {
    SearchAggregationType["DateHistogram"] = "dateHistogram";
    SearchAggregationType["DateRange"] = "dateRange";
    SearchAggregationType["Histogram"] = "histogram";
    SearchAggregationType["Metric"] = "metric";
    SearchAggregationType["Range"] = "range";
    SearchAggregationType["Terms"] = "terms";
    SearchAggregationType["TopHits"] = "topHits";
})(SearchAggregationType || (SearchAggregationType = {}));
export var SearchAggregationsAllowedPropertiesForDateHistogramAggregation;
(function (SearchAggregationsAllowedPropertiesForDateHistogramAggregation) {
    SearchAggregationsAllowedPropertiesForDateHistogramAggregation["CreatedAt"] = "createdAt";
    SearchAggregationsAllowedPropertiesForDateHistogramAggregation["MetadataDocumentCustomPropertyDate01"] = "metadataDocumentCustomPropertyDate01";
    SearchAggregationsAllowedPropertiesForDateHistogramAggregation["MetadataDocumentCustomPropertyDate02"] = "metadataDocumentCustomPropertyDate02";
    SearchAggregationsAllowedPropertiesForDateHistogramAggregation["MetadataDocumentCustomPropertyDate03"] = "metadataDocumentCustomPropertyDate03";
    SearchAggregationsAllowedPropertiesForDateHistogramAggregation["MetadataDocumentCustomPropertyDate04"] = "metadataDocumentCustomPropertyDate04";
    SearchAggregationsAllowedPropertiesForDateHistogramAggregation["MetadataDocumentCustomPropertyDate05"] = "metadataDocumentCustomPropertyDate05";
    SearchAggregationsAllowedPropertiesForDateHistogramAggregation["MetadataDocumentCustomPropertyDate06"] = "metadataDocumentCustomPropertyDate06";
    SearchAggregationsAllowedPropertiesForDateHistogramAggregation["MetadataDocumentCustomPropertyDate07"] = "metadataDocumentCustomPropertyDate07";
    SearchAggregationsAllowedPropertiesForDateHistogramAggregation["MetadataDocumentCustomPropertyDate08"] = "metadataDocumentCustomPropertyDate08";
    SearchAggregationsAllowedPropertiesForDateHistogramAggregation["MetadataDocumentCustomPropertyDate09"] = "metadataDocumentCustomPropertyDate09";
    SearchAggregationsAllowedPropertiesForDateHistogramAggregation["MetadataDocumentCustomPropertyDate10"] = "metadataDocumentCustomPropertyDate10";
    SearchAggregationsAllowedPropertiesForDateHistogramAggregation["MetadataDocumentCustomPropertyDate11"] = "metadataDocumentCustomPropertyDate11";
    SearchAggregationsAllowedPropertiesForDateHistogramAggregation["MetadataDocumentCustomPropertyDate12"] = "metadataDocumentCustomPropertyDate12";
    SearchAggregationsAllowedPropertiesForDateHistogramAggregation["MetadataDocumentCustomPropertyDate13"] = "metadataDocumentCustomPropertyDate13";
    SearchAggregationsAllowedPropertiesForDateHistogramAggregation["MetadataDocumentCustomPropertyDate14"] = "metadataDocumentCustomPropertyDate14";
    SearchAggregationsAllowedPropertiesForDateHistogramAggregation["MetadataDocumentCustomPropertyDate15"] = "metadataDocumentCustomPropertyDate15";
    SearchAggregationsAllowedPropertiesForDateHistogramAggregation["MetadataDocumentCustomPropertyDate16"] = "metadataDocumentCustomPropertyDate16";
    SearchAggregationsAllowedPropertiesForDateHistogramAggregation["MetadataDocumentCustomPropertyDate17"] = "metadataDocumentCustomPropertyDate17";
    SearchAggregationsAllowedPropertiesForDateHistogramAggregation["MetadataDocumentCustomPropertyDate18"] = "metadataDocumentCustomPropertyDate18";
    SearchAggregationsAllowedPropertiesForDateHistogramAggregation["MetadataDocumentCustomPropertyDate19"] = "metadataDocumentCustomPropertyDate19";
    SearchAggregationsAllowedPropertiesForDateHistogramAggregation["MetadataDocumentCustomPropertyDate20"] = "metadataDocumentCustomPropertyDate20";
    SearchAggregationsAllowedPropertiesForDateHistogramAggregation["MetadataDocumentDateSigned"] = "metadataDocumentDateSigned";
    SearchAggregationsAllowedPropertiesForDateHistogramAggregation["MetadataDocumentNoticeDate"] = "metadataDocumentNoticeDate";
    SearchAggregationsAllowedPropertiesForDateHistogramAggregation["MetadataDocumentProbationaryPeriodExpirationDate"] = "metadataDocumentProbationaryPeriodExpirationDate";
    SearchAggregationsAllowedPropertiesForDateHistogramAggregation["MetadataDocumentStartDate"] = "metadataDocumentStartDate";
    SearchAggregationsAllowedPropertiesForDateHistogramAggregation["MetadataDocumentTerminationDate"] = "metadataDocumentTerminationDate";
    SearchAggregationsAllowedPropertiesForDateHistogramAggregation["MetadataProjectNoticeDate"] = "metadataProjectNoticeDate";
    SearchAggregationsAllowedPropertiesForDateHistogramAggregation["MetadataProjectSigningDate"] = "metadataProjectSigningDate";
    SearchAggregationsAllowedPropertiesForDateHistogramAggregation["MetadataProjectTerminationDate"] = "metadataProjectTerminationDate";
    SearchAggregationsAllowedPropertiesForDateHistogramAggregation["MetadataTaskDueDate"] = "metadataTaskDueDate";
    SearchAggregationsAllowedPropertiesForDateHistogramAggregation["UpdatedAt"] = "updatedAt";
})(SearchAggregationsAllowedPropertiesForDateHistogramAggregation || (SearchAggregationsAllowedPropertiesForDateHistogramAggregation = {}));
export var SearchAggregationsAllowedPropertiesForDateRangeAggregation;
(function (SearchAggregationsAllowedPropertiesForDateRangeAggregation) {
    SearchAggregationsAllowedPropertiesForDateRangeAggregation["CreatedAt"] = "createdAt";
    SearchAggregationsAllowedPropertiesForDateRangeAggregation["MetadataDocumentCustomPropertyDate01"] = "metadataDocumentCustomPropertyDate01";
    SearchAggregationsAllowedPropertiesForDateRangeAggregation["MetadataDocumentCustomPropertyDate02"] = "metadataDocumentCustomPropertyDate02";
    SearchAggregationsAllowedPropertiesForDateRangeAggregation["MetadataDocumentCustomPropertyDate03"] = "metadataDocumentCustomPropertyDate03";
    SearchAggregationsAllowedPropertiesForDateRangeAggregation["MetadataDocumentCustomPropertyDate04"] = "metadataDocumentCustomPropertyDate04";
    SearchAggregationsAllowedPropertiesForDateRangeAggregation["MetadataDocumentCustomPropertyDate05"] = "metadataDocumentCustomPropertyDate05";
    SearchAggregationsAllowedPropertiesForDateRangeAggregation["MetadataDocumentCustomPropertyDate06"] = "metadataDocumentCustomPropertyDate06";
    SearchAggregationsAllowedPropertiesForDateRangeAggregation["MetadataDocumentCustomPropertyDate07"] = "metadataDocumentCustomPropertyDate07";
    SearchAggregationsAllowedPropertiesForDateRangeAggregation["MetadataDocumentCustomPropertyDate08"] = "metadataDocumentCustomPropertyDate08";
    SearchAggregationsAllowedPropertiesForDateRangeAggregation["MetadataDocumentCustomPropertyDate09"] = "metadataDocumentCustomPropertyDate09";
    SearchAggregationsAllowedPropertiesForDateRangeAggregation["MetadataDocumentCustomPropertyDate10"] = "metadataDocumentCustomPropertyDate10";
    SearchAggregationsAllowedPropertiesForDateRangeAggregation["MetadataDocumentCustomPropertyDate11"] = "metadataDocumentCustomPropertyDate11";
    SearchAggregationsAllowedPropertiesForDateRangeAggregation["MetadataDocumentCustomPropertyDate12"] = "metadataDocumentCustomPropertyDate12";
    SearchAggregationsAllowedPropertiesForDateRangeAggregation["MetadataDocumentCustomPropertyDate13"] = "metadataDocumentCustomPropertyDate13";
    SearchAggregationsAllowedPropertiesForDateRangeAggregation["MetadataDocumentCustomPropertyDate14"] = "metadataDocumentCustomPropertyDate14";
    SearchAggregationsAllowedPropertiesForDateRangeAggregation["MetadataDocumentCustomPropertyDate15"] = "metadataDocumentCustomPropertyDate15";
    SearchAggregationsAllowedPropertiesForDateRangeAggregation["MetadataDocumentCustomPropertyDate16"] = "metadataDocumentCustomPropertyDate16";
    SearchAggregationsAllowedPropertiesForDateRangeAggregation["MetadataDocumentCustomPropertyDate17"] = "metadataDocumentCustomPropertyDate17";
    SearchAggregationsAllowedPropertiesForDateRangeAggregation["MetadataDocumentCustomPropertyDate18"] = "metadataDocumentCustomPropertyDate18";
    SearchAggregationsAllowedPropertiesForDateRangeAggregation["MetadataDocumentCustomPropertyDate19"] = "metadataDocumentCustomPropertyDate19";
    SearchAggregationsAllowedPropertiesForDateRangeAggregation["MetadataDocumentCustomPropertyDate20"] = "metadataDocumentCustomPropertyDate20";
    SearchAggregationsAllowedPropertiesForDateRangeAggregation["MetadataDocumentDateSigned"] = "metadataDocumentDateSigned";
    SearchAggregationsAllowedPropertiesForDateRangeAggregation["MetadataDocumentNoticeDate"] = "metadataDocumentNoticeDate";
    SearchAggregationsAllowedPropertiesForDateRangeAggregation["MetadataDocumentProbationaryPeriodExpirationDate"] = "metadataDocumentProbationaryPeriodExpirationDate";
    SearchAggregationsAllowedPropertiesForDateRangeAggregation["MetadataDocumentStartDate"] = "metadataDocumentStartDate";
    SearchAggregationsAllowedPropertiesForDateRangeAggregation["MetadataDocumentTerminationDate"] = "metadataDocumentTerminationDate";
    SearchAggregationsAllowedPropertiesForDateRangeAggregation["MetadataProjectNoticeDate"] = "metadataProjectNoticeDate";
    SearchAggregationsAllowedPropertiesForDateRangeAggregation["MetadataProjectSigningDate"] = "metadataProjectSigningDate";
    SearchAggregationsAllowedPropertiesForDateRangeAggregation["MetadataProjectTerminationDate"] = "metadataProjectTerminationDate";
    SearchAggregationsAllowedPropertiesForDateRangeAggregation["MetadataTaskDueDate"] = "metadataTaskDueDate";
    SearchAggregationsAllowedPropertiesForDateRangeAggregation["UpdatedAt"] = "updatedAt";
})(SearchAggregationsAllowedPropertiesForDateRangeAggregation || (SearchAggregationsAllowedPropertiesForDateRangeAggregation = {}));
export var SearchAggregationsAllowedPropertiesForHistogramAggregation;
(function (SearchAggregationsAllowedPropertiesForHistogramAggregation) {
    SearchAggregationsAllowedPropertiesForHistogramAggregation["EntityId"] = "entityId";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyFloat01"] = "metadataDocumentCustomPropertyFloat01";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyFloat02"] = "metadataDocumentCustomPropertyFloat02";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyFloat03"] = "metadataDocumentCustomPropertyFloat03";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyFloat04"] = "metadataDocumentCustomPropertyFloat04";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyFloat05"] = "metadataDocumentCustomPropertyFloat05";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyFloat06"] = "metadataDocumentCustomPropertyFloat06";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyFloat07"] = "metadataDocumentCustomPropertyFloat07";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyFloat08"] = "metadataDocumentCustomPropertyFloat08";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyFloat09"] = "metadataDocumentCustomPropertyFloat09";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyFloat10"] = "metadataDocumentCustomPropertyFloat10";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyFloat11"] = "metadataDocumentCustomPropertyFloat11";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyFloat12"] = "metadataDocumentCustomPropertyFloat12";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyFloat13"] = "metadataDocumentCustomPropertyFloat13";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyFloat14"] = "metadataDocumentCustomPropertyFloat14";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyFloat15"] = "metadataDocumentCustomPropertyFloat15";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyFloat16"] = "metadataDocumentCustomPropertyFloat16";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyFloat17"] = "metadataDocumentCustomPropertyFloat17";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyFloat18"] = "metadataDocumentCustomPropertyFloat18";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyFloat19"] = "metadataDocumentCustomPropertyFloat19";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyFloat20"] = "metadataDocumentCustomPropertyFloat20";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyNumber01"] = "metadataDocumentCustomPropertyNumber01";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyNumber02"] = "metadataDocumentCustomPropertyNumber02";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyNumber03"] = "metadataDocumentCustomPropertyNumber03";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyNumber04"] = "metadataDocumentCustomPropertyNumber04";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyNumber05"] = "metadataDocumentCustomPropertyNumber05";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyNumber06"] = "metadataDocumentCustomPropertyNumber06";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyNumber07"] = "metadataDocumentCustomPropertyNumber07";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyNumber08"] = "metadataDocumentCustomPropertyNumber08";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyNumber09"] = "metadataDocumentCustomPropertyNumber09";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyNumber10"] = "metadataDocumentCustomPropertyNumber10";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyNumber11"] = "metadataDocumentCustomPropertyNumber11";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyNumber12"] = "metadataDocumentCustomPropertyNumber12";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyNumber13"] = "metadataDocumentCustomPropertyNumber13";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyNumber14"] = "metadataDocumentCustomPropertyNumber14";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyNumber15"] = "metadataDocumentCustomPropertyNumber15";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyNumber16"] = "metadataDocumentCustomPropertyNumber16";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyNumber17"] = "metadataDocumentCustomPropertyNumber17";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyNumber18"] = "metadataDocumentCustomPropertyNumber18";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyNumber19"] = "metadataDocumentCustomPropertyNumber19";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentCustomPropertyNumber20"] = "metadataDocumentCustomPropertyNumber20";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentLiabilityCap"] = "metadataDocumentLiabilityCap";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentNoticePeriodDays"] = "metadataDocumentNoticePeriodDays";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentNoticePeriodMonths"] = "metadataDocumentNoticePeriodMonths";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentOriginalTermMonths"] = "metadataDocumentOriginalTermMonths";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentPaymentTermsDaysFromInvoiceDate"] = "metadataDocumentPaymentTermsDaysFromInvoiceDate";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentRenewalTermMonths"] = "metadataDocumentRenewalTermMonths";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentTotalContractCost"] = "metadataDocumentTotalContractCost";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataDocumentTotalContractValue"] = "metadataDocumentTotalContractValue";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataProjectDocumentsCount"] = "metadataProjectDocumentsCount";
    SearchAggregationsAllowedPropertiesForHistogramAggregation["MetadataProjectValue"] = "metadataProjectValue";
})(SearchAggregationsAllowedPropertiesForHistogramAggregation || (SearchAggregationsAllowedPropertiesForHistogramAggregation = {}));
export var SearchAggregationsAllowedPropertiesForMetricAggregation;
(function (SearchAggregationsAllowedPropertiesForMetricAggregation) {
    SearchAggregationsAllowedPropertiesForMetricAggregation["EntityId"] = "entityId";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyFloat01"] = "metadataDocumentCustomPropertyFloat01";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyFloat02"] = "metadataDocumentCustomPropertyFloat02";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyFloat03"] = "metadataDocumentCustomPropertyFloat03";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyFloat04"] = "metadataDocumentCustomPropertyFloat04";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyFloat05"] = "metadataDocumentCustomPropertyFloat05";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyFloat06"] = "metadataDocumentCustomPropertyFloat06";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyFloat07"] = "metadataDocumentCustomPropertyFloat07";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyFloat08"] = "metadataDocumentCustomPropertyFloat08";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyFloat09"] = "metadataDocumentCustomPropertyFloat09";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyFloat10"] = "metadataDocumentCustomPropertyFloat10";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyFloat11"] = "metadataDocumentCustomPropertyFloat11";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyFloat12"] = "metadataDocumentCustomPropertyFloat12";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyFloat13"] = "metadataDocumentCustomPropertyFloat13";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyFloat14"] = "metadataDocumentCustomPropertyFloat14";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyFloat15"] = "metadataDocumentCustomPropertyFloat15";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyFloat16"] = "metadataDocumentCustomPropertyFloat16";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyFloat17"] = "metadataDocumentCustomPropertyFloat17";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyFloat18"] = "metadataDocumentCustomPropertyFloat18";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyFloat19"] = "metadataDocumentCustomPropertyFloat19";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyFloat20"] = "metadataDocumentCustomPropertyFloat20";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyNumber01"] = "metadataDocumentCustomPropertyNumber01";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyNumber02"] = "metadataDocumentCustomPropertyNumber02";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyNumber03"] = "metadataDocumentCustomPropertyNumber03";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyNumber04"] = "metadataDocumentCustomPropertyNumber04";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyNumber05"] = "metadataDocumentCustomPropertyNumber05";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyNumber06"] = "metadataDocumentCustomPropertyNumber06";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyNumber07"] = "metadataDocumentCustomPropertyNumber07";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyNumber08"] = "metadataDocumentCustomPropertyNumber08";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyNumber09"] = "metadataDocumentCustomPropertyNumber09";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyNumber10"] = "metadataDocumentCustomPropertyNumber10";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyNumber11"] = "metadataDocumentCustomPropertyNumber11";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyNumber12"] = "metadataDocumentCustomPropertyNumber12";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyNumber13"] = "metadataDocumentCustomPropertyNumber13";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyNumber14"] = "metadataDocumentCustomPropertyNumber14";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyNumber15"] = "metadataDocumentCustomPropertyNumber15";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyNumber16"] = "metadataDocumentCustomPropertyNumber16";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyNumber17"] = "metadataDocumentCustomPropertyNumber17";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyNumber18"] = "metadataDocumentCustomPropertyNumber18";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyNumber19"] = "metadataDocumentCustomPropertyNumber19";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentCustomPropertyNumber20"] = "metadataDocumentCustomPropertyNumber20";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentLiabilityCap"] = "metadataDocumentLiabilityCap";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentNoticePeriodDays"] = "metadataDocumentNoticePeriodDays";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentNoticePeriodMonths"] = "metadataDocumentNoticePeriodMonths";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentOriginalTermMonths"] = "metadataDocumentOriginalTermMonths";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentPaymentTermsDaysFromInvoiceDate"] = "metadataDocumentPaymentTermsDaysFromInvoiceDate";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentRenewalTermMonths"] = "metadataDocumentRenewalTermMonths";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentTotalContractCost"] = "metadataDocumentTotalContractCost";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataDocumentTotalContractValue"] = "metadataDocumentTotalContractValue";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataProjectDocumentsCount"] = "metadataProjectDocumentsCount";
    SearchAggregationsAllowedPropertiesForMetricAggregation["MetadataProjectValue"] = "metadataProjectValue";
})(SearchAggregationsAllowedPropertiesForMetricAggregation || (SearchAggregationsAllowedPropertiesForMetricAggregation = {}));
export var SearchAggregationsAllowedPropertiesForRangeAggregation;
(function (SearchAggregationsAllowedPropertiesForRangeAggregation) {
    SearchAggregationsAllowedPropertiesForRangeAggregation["EntityId"] = "entityId";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyFloat01"] = "metadataDocumentCustomPropertyFloat01";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyFloat02"] = "metadataDocumentCustomPropertyFloat02";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyFloat03"] = "metadataDocumentCustomPropertyFloat03";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyFloat04"] = "metadataDocumentCustomPropertyFloat04";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyFloat05"] = "metadataDocumentCustomPropertyFloat05";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyFloat06"] = "metadataDocumentCustomPropertyFloat06";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyFloat07"] = "metadataDocumentCustomPropertyFloat07";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyFloat08"] = "metadataDocumentCustomPropertyFloat08";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyFloat09"] = "metadataDocumentCustomPropertyFloat09";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyFloat10"] = "metadataDocumentCustomPropertyFloat10";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyFloat11"] = "metadataDocumentCustomPropertyFloat11";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyFloat12"] = "metadataDocumentCustomPropertyFloat12";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyFloat13"] = "metadataDocumentCustomPropertyFloat13";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyFloat14"] = "metadataDocumentCustomPropertyFloat14";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyFloat15"] = "metadataDocumentCustomPropertyFloat15";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyFloat16"] = "metadataDocumentCustomPropertyFloat16";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyFloat17"] = "metadataDocumentCustomPropertyFloat17";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyFloat18"] = "metadataDocumentCustomPropertyFloat18";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyFloat19"] = "metadataDocumentCustomPropertyFloat19";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyFloat20"] = "metadataDocumentCustomPropertyFloat20";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyNumber01"] = "metadataDocumentCustomPropertyNumber01";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyNumber02"] = "metadataDocumentCustomPropertyNumber02";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyNumber03"] = "metadataDocumentCustomPropertyNumber03";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyNumber04"] = "metadataDocumentCustomPropertyNumber04";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyNumber05"] = "metadataDocumentCustomPropertyNumber05";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyNumber06"] = "metadataDocumentCustomPropertyNumber06";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyNumber07"] = "metadataDocumentCustomPropertyNumber07";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyNumber08"] = "metadataDocumentCustomPropertyNumber08";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyNumber09"] = "metadataDocumentCustomPropertyNumber09";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyNumber10"] = "metadataDocumentCustomPropertyNumber10";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyNumber11"] = "metadataDocumentCustomPropertyNumber11";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyNumber12"] = "metadataDocumentCustomPropertyNumber12";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyNumber13"] = "metadataDocumentCustomPropertyNumber13";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyNumber14"] = "metadataDocumentCustomPropertyNumber14";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyNumber15"] = "metadataDocumentCustomPropertyNumber15";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyNumber16"] = "metadataDocumentCustomPropertyNumber16";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyNumber17"] = "metadataDocumentCustomPropertyNumber17";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyNumber18"] = "metadataDocumentCustomPropertyNumber18";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyNumber19"] = "metadataDocumentCustomPropertyNumber19";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentCustomPropertyNumber20"] = "metadataDocumentCustomPropertyNumber20";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentLiabilityCap"] = "metadataDocumentLiabilityCap";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentNoticePeriodDays"] = "metadataDocumentNoticePeriodDays";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentNoticePeriodMonths"] = "metadataDocumentNoticePeriodMonths";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentOriginalTermMonths"] = "metadataDocumentOriginalTermMonths";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentPaymentTermsDaysFromInvoiceDate"] = "metadataDocumentPaymentTermsDaysFromInvoiceDate";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentRenewalTermMonths"] = "metadataDocumentRenewalTermMonths";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentTotalContractCost"] = "metadataDocumentTotalContractCost";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataDocumentTotalContractValue"] = "metadataDocumentTotalContractValue";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataProjectDocumentsCount"] = "metadataProjectDocumentsCount";
    SearchAggregationsAllowedPropertiesForRangeAggregation["MetadataProjectValue"] = "metadataProjectValue";
})(SearchAggregationsAllowedPropertiesForRangeAggregation || (SearchAggregationsAllowedPropertiesForRangeAggregation = {}));
export var SearchAggregationsAllowedPropertiesForTermsAggregation;
(function (SearchAggregationsAllowedPropertiesForTermsAggregation) {
    SearchAggregationsAllowedPropertiesForTermsAggregation["CategoryId"] = "categoryId";
    SearchAggregationsAllowedPropertiesForTermsAggregation["CreatedByUserId"] = "createdByUserId";
    SearchAggregationsAllowedPropertiesForTermsAggregation["EntityType"] = "entityType";
    SearchAggregationsAllowedPropertiesForTermsAggregation["IsPlGenerated"] = "isPlGenerated";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MarketCode"] = "marketCode";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MarketLocaleCode"] = "marketLocaleCode";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentActive"] = "metadataDocumentActive";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentAutomaticRenewal"] = "metadataDocumentAutomaticRenewal";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentContractOwner"] = "metadataDocumentContractOwner";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentContractRole"] = "metadataDocumentContractRole";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCountry"] = "metadataDocumentCountry";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCurrency"] = "metadataDocumentCurrency";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyBoolean01"] = "metadataDocumentCustomPropertyBoolean01";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyBoolean02"] = "metadataDocumentCustomPropertyBoolean02";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyBoolean03"] = "metadataDocumentCustomPropertyBoolean03";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyBoolean04"] = "metadataDocumentCustomPropertyBoolean04";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyBoolean05"] = "metadataDocumentCustomPropertyBoolean05";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyBoolean06"] = "metadataDocumentCustomPropertyBoolean06";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyBoolean07"] = "metadataDocumentCustomPropertyBoolean07";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyBoolean08"] = "metadataDocumentCustomPropertyBoolean08";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyBoolean09"] = "metadataDocumentCustomPropertyBoolean09";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyBoolean10"] = "metadataDocumentCustomPropertyBoolean10";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyBoolean11"] = "metadataDocumentCustomPropertyBoolean11";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyBoolean12"] = "metadataDocumentCustomPropertyBoolean12";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyBoolean13"] = "metadataDocumentCustomPropertyBoolean13";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyBoolean14"] = "metadataDocumentCustomPropertyBoolean14";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyBoolean15"] = "metadataDocumentCustomPropertyBoolean15";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyBoolean16"] = "metadataDocumentCustomPropertyBoolean16";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyBoolean17"] = "metadataDocumentCustomPropertyBoolean17";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyBoolean18"] = "metadataDocumentCustomPropertyBoolean18";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyBoolean19"] = "metadataDocumentCustomPropertyBoolean19";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyBoolean20"] = "metadataDocumentCustomPropertyBoolean20";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeyword01"] = "metadataDocumentCustomPropertyKeyword01";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeyword02"] = "metadataDocumentCustomPropertyKeyword02";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeyword03"] = "metadataDocumentCustomPropertyKeyword03";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeyword04"] = "metadataDocumentCustomPropertyKeyword04";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeyword05"] = "metadataDocumentCustomPropertyKeyword05";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeyword06"] = "metadataDocumentCustomPropertyKeyword06";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeyword07"] = "metadataDocumentCustomPropertyKeyword07";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeyword08"] = "metadataDocumentCustomPropertyKeyword08";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeyword09"] = "metadataDocumentCustomPropertyKeyword09";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeyword10"] = "metadataDocumentCustomPropertyKeyword10";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeyword11"] = "metadataDocumentCustomPropertyKeyword11";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeyword12"] = "metadataDocumentCustomPropertyKeyword12";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeyword13"] = "metadataDocumentCustomPropertyKeyword13";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeyword14"] = "metadataDocumentCustomPropertyKeyword14";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeyword15"] = "metadataDocumentCustomPropertyKeyword15";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeyword16"] = "metadataDocumentCustomPropertyKeyword16";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeyword17"] = "metadataDocumentCustomPropertyKeyword17";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeyword18"] = "metadataDocumentCustomPropertyKeyword18";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeyword19"] = "metadataDocumentCustomPropertyKeyword19";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeyword20"] = "metadataDocumentCustomPropertyKeyword20";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeywordArray01"] = "metadataDocumentCustomPropertyKeywordArray01";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeywordArray02"] = "metadataDocumentCustomPropertyKeywordArray02";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeywordArray03"] = "metadataDocumentCustomPropertyKeywordArray03";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeywordArray04"] = "metadataDocumentCustomPropertyKeywordArray04";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeywordArray05"] = "metadataDocumentCustomPropertyKeywordArray05";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeywordArray06"] = "metadataDocumentCustomPropertyKeywordArray06";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeywordArray07"] = "metadataDocumentCustomPropertyKeywordArray07";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeywordArray08"] = "metadataDocumentCustomPropertyKeywordArray08";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeywordArray09"] = "metadataDocumentCustomPropertyKeywordArray09";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeywordArray10"] = "metadataDocumentCustomPropertyKeywordArray10";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeywordArray11"] = "metadataDocumentCustomPropertyKeywordArray11";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeywordArray12"] = "metadataDocumentCustomPropertyKeywordArray12";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeywordArray13"] = "metadataDocumentCustomPropertyKeywordArray13";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeywordArray14"] = "metadataDocumentCustomPropertyKeywordArray14";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeywordArray15"] = "metadataDocumentCustomPropertyKeywordArray15";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeywordArray16"] = "metadataDocumentCustomPropertyKeywordArray16";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeywordArray17"] = "metadataDocumentCustomPropertyKeywordArray17";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeywordArray18"] = "metadataDocumentCustomPropertyKeywordArray18";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeywordArray19"] = "metadataDocumentCustomPropertyKeywordArray19";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyKeywordArray20"] = "metadataDocumentCustomPropertyKeywordArray20";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyText01"] = "metadataDocumentCustomPropertyText01";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyText02"] = "metadataDocumentCustomPropertyText02";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyText03"] = "metadataDocumentCustomPropertyText03";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyText04"] = "metadataDocumentCustomPropertyText04";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyText05"] = "metadataDocumentCustomPropertyText05";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyText06"] = "metadataDocumentCustomPropertyText06";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyText07"] = "metadataDocumentCustomPropertyText07";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyText08"] = "metadataDocumentCustomPropertyText08";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyText09"] = "metadataDocumentCustomPropertyText09";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyText10"] = "metadataDocumentCustomPropertyText10";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyText11"] = "metadataDocumentCustomPropertyText11";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyText12"] = "metadataDocumentCustomPropertyText12";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyText13"] = "metadataDocumentCustomPropertyText13";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyText14"] = "metadataDocumentCustomPropertyText14";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyText15"] = "metadataDocumentCustomPropertyText15";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyText16"] = "metadataDocumentCustomPropertyText16";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyText17"] = "metadataDocumentCustomPropertyText17";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyText18"] = "metadataDocumentCustomPropertyText18";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyText19"] = "metadataDocumentCustomPropertyText19";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyText20"] = "metadataDocumentCustomPropertyText20";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyTextArray01"] = "metadataDocumentCustomPropertyTextArray01";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyTextArray02"] = "metadataDocumentCustomPropertyTextArray02";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyTextArray03"] = "metadataDocumentCustomPropertyTextArray03";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyTextArray04"] = "metadataDocumentCustomPropertyTextArray04";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyTextArray05"] = "metadataDocumentCustomPropertyTextArray05";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyTextArray06"] = "metadataDocumentCustomPropertyTextArray06";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyTextArray07"] = "metadataDocumentCustomPropertyTextArray07";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyTextArray08"] = "metadataDocumentCustomPropertyTextArray08";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyTextArray09"] = "metadataDocumentCustomPropertyTextArray09";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyTextArray10"] = "metadataDocumentCustomPropertyTextArray10";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyTextArray11"] = "metadataDocumentCustomPropertyTextArray11";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyTextArray12"] = "metadataDocumentCustomPropertyTextArray12";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyTextArray13"] = "metadataDocumentCustomPropertyTextArray13";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyTextArray14"] = "metadataDocumentCustomPropertyTextArray14";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyTextArray15"] = "metadataDocumentCustomPropertyTextArray15";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyTextArray16"] = "metadataDocumentCustomPropertyTextArray16";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyTextArray17"] = "metadataDocumentCustomPropertyTextArray17";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyTextArray18"] = "metadataDocumentCustomPropertyTextArray18";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyTextArray19"] = "metadataDocumentCustomPropertyTextArray19";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentCustomPropertyTextArray20"] = "metadataDocumentCustomPropertyTextArray20";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentDeviateFromStandard"] = "metadataDocumentDeviateFromStandard";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentDiscount"] = "metadataDocumentDiscount";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentDocumentCategory"] = "metadataDocumentDocumentCategory";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentDocumentType"] = "metadataDocumentDocumentType";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentEsigningStatus"] = "metadataDocumentEsigningStatus";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentFeeAdjustmentClause"] = "metadataDocumentFeeAdjustmentClause";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentGoverningLaw"] = "metadataDocumentGoverningLaw";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentIndemnity"] = "metadataDocumentIndemnity";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentIsSharedExternally"] = "metadataDocumentIsSharedExternally";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentLiabilityCapScope"] = "metadataDocumentLiabilityCapScope";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentLimitationOfLiability"] = "metadataDocumentLimitationOfLiability";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentMarketingTrademarkUse"] = "metadataDocumentMarketingTrademarkUse";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentMaterialAgreement"] = "metadataDocumentMaterialAgreement";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentOriginalVersionStored"] = "metadataDocumentOriginalVersionStored";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentOutsourcing"] = "metadataDocumentOutsourcing";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentParties"] = "metadataDocumentParties";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentPostTerminationObligations"] = "metadataDocumentPostTerminationObligations";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentProbationaryPeriod"] = "metadataDocumentProbationaryPeriod";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentProcessingOfPersonalData"] = "metadataDocumentProcessingOfPersonalData";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentStatus"] = "metadataDocumentStatus";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentTerminationForCause"] = "metadataDocumentTerminationForCause";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentTerminationForConvenience"] = "metadataDocumentTerminationForConvenience";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataDocumentType"] = "metadataDocumentType";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataEntryPath"] = "metadataEntryPath";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataProjectContractTerm"] = "metadataProjectContractTerm";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataProjectCounterparties"] = "metadataProjectCounterparties";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataProjectCurrency"] = "metadataProjectCurrency";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataProjectOurParties"] = "metadataProjectOurParties";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataProjectProjectOwner"] = "metadataProjectProjectOwner";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataProjectStatus"] = "metadataProjectStatus";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataTaskIsPublic"] = "metadataTaskIsPublic";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataTaskStatus"] = "metadataTaskStatus";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataTemplateComposerId"] = "metadataTemplateComposerId";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataTemplateMarketLocaleCode"] = "metadataTemplateMarketLocaleCode";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataUserEmail"] = "metadataUserEmail";
    SearchAggregationsAllowedPropertiesForTermsAggregation["MetadataUserRole"] = "metadataUserRole";
})(SearchAggregationsAllowedPropertiesForTermsAggregation || (SearchAggregationsAllowedPropertiesForTermsAggregation = {}));
export var SearchDocumentTypeEnum;
(function (SearchDocumentTypeEnum) {
    SearchDocumentTypeEnum["Composed"] = "COMPOSED";
    SearchDocumentTypeEnum["Freetext"] = "FREETEXT";
    SearchDocumentTypeEnum["Uploaded"] = "UPLOADED";
})(SearchDocumentTypeEnum || (SearchDocumentTypeEnum = {}));
export var SearchEntityTypeEnum;
(function (SearchEntityTypeEnum) {
    SearchEntityTypeEnum["Document"] = "document";
    SearchEntityTypeEnum["DocumentComposed"] = "document_composed";
    SearchEntityTypeEnum["DocumentFreetext"] = "document_freetext";
    SearchEntityTypeEnum["DocumentUploaded"] = "document_uploaded";
    SearchEntityTypeEnum["Draft"] = "draft";
    SearchEntityTypeEnum["Folder"] = "folder";
    SearchEntityTypeEnum["InboxFile"] = "inbox_file";
    SearchEntityTypeEnum["Project"] = "project";
    SearchEntityTypeEnum["Task"] = "task";
    SearchEntityTypeEnum["Template"] = "template";
    SearchEntityTypeEnum["User"] = "user";
})(SearchEntityTypeEnum || (SearchEntityTypeEnum = {}));
export var SearchFeature;
(function (SearchFeature) {
    SearchFeature["AiCharts"] = "AI_CHARTS";
})(SearchFeature || (SearchFeature = {}));
export var SearchInsightsWidgetTypeEnum;
(function (SearchInsightsWidgetTypeEnum) {
    SearchInsightsWidgetTypeEnum["Barchart"] = "barchart";
    SearchInsightsWidgetTypeEnum["Count"] = "count";
    SearchInsightsWidgetTypeEnum["Doughnut"] = "doughnut";
    SearchInsightsWidgetTypeEnum["Linechart"] = "linechart";
    SearchInsightsWidgetTypeEnum["Table"] = "table";
})(SearchInsightsWidgetTypeEnum || (SearchInsightsWidgetTypeEnum = {}));
export var SearchMarketLocaleCodeEnum;
(function (SearchMarketLocaleCodeEnum) {
    SearchMarketLocaleCodeEnum["De"] = "de";
    SearchMarketLocaleCodeEnum["En"] = "en";
    SearchMarketLocaleCodeEnum["Nb"] = "nb";
    SearchMarketLocaleCodeEnum["Sv"] = "sv";
})(SearchMarketLocaleCodeEnum || (SearchMarketLocaleCodeEnum = {}));
export var SearchTextFieldAllowedPropertiesForTextFieldSearch;
(function (SearchTextFieldAllowedPropertiesForTextFieldSearch) {
    SearchTextFieldAllowedPropertiesForTextFieldSearch["AllApplicable"] = "_allApplicable";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["Body"] = "body";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["Description"] = "description";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["EntityId"] = "entityId";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCountry"] = "metadataDocumentCountry";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCurrency"] = "metadataDocumentCurrency";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyText01"] = "metadataDocumentCustomPropertyText01";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyText02"] = "metadataDocumentCustomPropertyText02";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyText03"] = "metadataDocumentCustomPropertyText03";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyText04"] = "metadataDocumentCustomPropertyText04";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyText05"] = "metadataDocumentCustomPropertyText05";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyText06"] = "metadataDocumentCustomPropertyText06";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyText07"] = "metadataDocumentCustomPropertyText07";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyText08"] = "metadataDocumentCustomPropertyText08";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyText09"] = "metadataDocumentCustomPropertyText09";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyText10"] = "metadataDocumentCustomPropertyText10";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyText11"] = "metadataDocumentCustomPropertyText11";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyText12"] = "metadataDocumentCustomPropertyText12";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyText13"] = "metadataDocumentCustomPropertyText13";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyText14"] = "metadataDocumentCustomPropertyText14";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyText15"] = "metadataDocumentCustomPropertyText15";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyText16"] = "metadataDocumentCustomPropertyText16";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyText17"] = "metadataDocumentCustomPropertyText17";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyText18"] = "metadataDocumentCustomPropertyText18";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyText19"] = "metadataDocumentCustomPropertyText19";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyText20"] = "metadataDocumentCustomPropertyText20";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyTextArray01"] = "metadataDocumentCustomPropertyTextArray01";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyTextArray02"] = "metadataDocumentCustomPropertyTextArray02";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyTextArray03"] = "metadataDocumentCustomPropertyTextArray03";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyTextArray04"] = "metadataDocumentCustomPropertyTextArray04";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyTextArray05"] = "metadataDocumentCustomPropertyTextArray05";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyTextArray06"] = "metadataDocumentCustomPropertyTextArray06";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyTextArray07"] = "metadataDocumentCustomPropertyTextArray07";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyTextArray08"] = "metadataDocumentCustomPropertyTextArray08";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyTextArray09"] = "metadataDocumentCustomPropertyTextArray09";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyTextArray10"] = "metadataDocumentCustomPropertyTextArray10";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyTextArray11"] = "metadataDocumentCustomPropertyTextArray11";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyTextArray12"] = "metadataDocumentCustomPropertyTextArray12";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyTextArray13"] = "metadataDocumentCustomPropertyTextArray13";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyTextArray14"] = "metadataDocumentCustomPropertyTextArray14";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyTextArray15"] = "metadataDocumentCustomPropertyTextArray15";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyTextArray16"] = "metadataDocumentCustomPropertyTextArray16";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyTextArray17"] = "metadataDocumentCustomPropertyTextArray17";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyTextArray18"] = "metadataDocumentCustomPropertyTextArray18";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyTextArray19"] = "metadataDocumentCustomPropertyTextArray19";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentCustomPropertyTextArray20"] = "metadataDocumentCustomPropertyTextArray20";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentDocumentCategory"] = "metadataDocumentDocumentCategory";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentDocumentType"] = "metadataDocumentDocumentType";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentEsigningStatus"] = "metadataDocumentEsigningStatus";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentGoverningLaw"] = "metadataDocumentGoverningLaw";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentNotes"] = "metadataDocumentNotes";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentOriginalVersionStored"] = "metadataDocumentOriginalVersionStored";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentParties"] = "metadataDocumentParties";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataDocumentProcessingOfPersonalData"] = "metadataDocumentProcessingOfPersonalData";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataProjectContractTerm"] = "metadataProjectContractTerm";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataProjectCounterparties"] = "metadataProjectCounterparties";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataProjectCurrency"] = "metadataProjectCurrency";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataProjectCustomerId"] = "metadataProjectCustomerId";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataProjectOurParties"] = "metadataProjectOurParties";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataProjectStatus"] = "metadataProjectStatus";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["MetadataUserEmail"] = "metadataUserEmail";
    SearchTextFieldAllowedPropertiesForTextFieldSearch["Name"] = "name";
})(SearchTextFieldAllowedPropertiesForTextFieldSearch || (SearchTextFieldAllowedPropertiesForTextFieldSearch = {}));
export var SearchTimeUnit;
(function (SearchTimeUnit) {
    SearchTimeUnit["Day"] = "day";
    SearchTimeUnit["Month"] = "month";
    SearchTimeUnit["Week"] = "week";
    SearchTimeUnit["Year"] = "year";
})(SearchTimeUnit || (SearchTimeUnit = {}));
export var SearchTypeEnum;
(function (SearchTypeEnum) {
    SearchTypeEnum["All"] = "all";
    SearchTypeEnum["Any"] = "any";
    SearchTypeEnum["AutocompleteName"] = "autocompleteName";
    SearchTypeEnum["ExactName"] = "exactName";
    SearchTypeEnum["Phrase"] = "phrase";
})(SearchTypeEnum || (SearchTypeEnum = {}));
export var SendSignRequestReminderRejectionReason;
(function (SendSignRequestReminderRejectionReason) {
    SendSignRequestReminderRejectionReason["AlreadyCancelled"] = "ALREADY_CANCELLED";
    SendSignRequestReminderRejectionReason["AlreadyCancelling"] = "ALREADY_CANCELLING";
    SendSignRequestReminderRejectionReason["AlreadySigned"] = "ALREADY_SIGNED";
    SendSignRequestReminderRejectionReason["NotAuthorized"] = "NOT_AUTHORIZED";
    SendSignRequestReminderRejectionReason["NotConnectedToEsigningProvider"] = "NOT_CONNECTED_TO_ESIGNING_PROVIDER";
    SendSignRequestReminderRejectionReason["NotFound"] = "NOT_FOUND";
    SendSignRequestReminderRejectionReason["ProviderRequestFailed"] = "PROVIDER_REQUEST_FAILED";
})(SendSignRequestReminderRejectionReason || (SendSignRequestReminderRejectionReason = {}));
export var SetEsigningRecipientsDocumentSealPositionsRejectionReason;
(function (SetEsigningRecipientsDocumentSealPositionsRejectionReason) {
    SetEsigningRecipientsDocumentSealPositionsRejectionReason["NotAuthorized"] = "NOT_AUTHORIZED";
})(SetEsigningRecipientsDocumentSealPositionsRejectionReason || (SetEsigningRecipientsDocumentSealPositionsRejectionReason = {}));
export var SharepointIntegrationUploadEventTrigger;
(function (SharepointIntegrationUploadEventTrigger) {
    SharepointIntegrationUploadEventTrigger["DocumentStatusSigned"] = "DOCUMENT_STATUS_SIGNED";
    SharepointIntegrationUploadEventTrigger["ESigningSigned"] = "E_SIGNING_SIGNED";
})(SharepointIntegrationUploadEventTrigger || (SharepointIntegrationUploadEventTrigger = {}));
export var SignRequestStatus;
(function (SignRequestStatus) {
    SignRequestStatus["Cancelled"] = "CANCELLED";
    SignRequestStatus["Cancelling"] = "CANCELLING";
    SignRequestStatus["Creating"] = "CREATING";
    SignRequestStatus["Failed"] = "FAILED";
    SignRequestStatus["Opened"] = "OPENED";
    SignRequestStatus["Pending"] = "PENDING";
    SignRequestStatus["Rejected"] = "REJECTED";
    SignRequestStatus["Signed"] = "SIGNED";
    SignRequestStatus["Unknown"] = "UNKNOWN";
})(SignRequestStatus || (SignRequestStatus = {}));
export var SignRequestsDistinctOn;
(function (SignRequestsDistinctOn) {
    SignRequestsDistinctOn["CreatedAt"] = "createdAt";
    SignRequestsDistinctOn["FileSystemDocumentId"] = "fileSystemDocumentId";
})(SignRequestsDistinctOn || (SignRequestsDistinctOn = {}));
export var SignatoryStatus;
(function (SignatoryStatus) {
    SignatoryStatus["Draft"] = "DRAFT";
    SignatoryStatus["Failed"] = "FAILED";
    SignatoryStatus["Opened"] = "OPENED";
    SignatoryStatus["Pending"] = "PENDING";
    SignatoryStatus["Rejected"] = "REJECTED";
    SignatoryStatus["Signed"] = "SIGNED";
    SignatoryStatus["Unknown"] = "UNKNOWN";
})(SignatoryStatus || (SignatoryStatus = {}));
export var StringFormat;
(function (StringFormat) {
    StringFormat["Html"] = "HTML";
    StringFormat["Markdown"] = "MARKDOWN";
    StringFormat["Text"] = "TEXT";
})(StringFormat || (StringFormat = {}));
/** unique or primary key constraints on table "pl.task_assignee" */
export var TaskAssigneeConstraint;
(function (TaskAssigneeConstraint) {
    /** unique or primary key constraint on columns "id" */
    TaskAssigneeConstraint["TaskAssigneePkey"] = "task_assignee_pkey";
    /** unique or primary key constraint on columns "task_id", "assignee_id" */
    TaskAssigneeConstraint["TaskAssigneeTaskIdAssigneeIdKey"] = "task_assignee_task_id_assignee_id_key";
})(TaskAssigneeConstraint || (TaskAssigneeConstraint = {}));
/** select columns of table "pl.task_assignee" */
export var TaskAssigneeSelectColumn;
(function (TaskAssigneeSelectColumn) {
    /** column name */
    TaskAssigneeSelectColumn["AssigneeId"] = "assignee_id";
    /** column name */
    TaskAssigneeSelectColumn["Id"] = "id";
    /** column name */
    TaskAssigneeSelectColumn["TaskId"] = "task_id";
})(TaskAssigneeSelectColumn || (TaskAssigneeSelectColumn = {}));
/** update columns of table "pl.task_assignee" */
export var TaskAssigneeUpdateColumn;
(function (TaskAssigneeUpdateColumn) {
    /** column name */
    TaskAssigneeUpdateColumn["AssigneeId"] = "assignee_id";
    /** column name */
    TaskAssigneeUpdateColumn["Id"] = "id";
    /** column name */
    TaskAssigneeUpdateColumn["TaskId"] = "task_id";
})(TaskAssigneeUpdateColumn || (TaskAssigneeUpdateColumn = {}));
/** unique or primary key constraints on table "pl.task" */
export var TaskConstraint;
(function (TaskConstraint) {
    /** unique or primary key constraint on columns "id" */
    TaskConstraint["TaskPkey"] = "task_pkey";
})(TaskConstraint || (TaskConstraint = {}));
/** unique or primary key constraints on table "pl.task_document" */
export var TaskDocumentConstraint;
(function (TaskDocumentConstraint) {
    /** unique or primary key constraint on columns "id" */
    TaskDocumentConstraint["TaskDocumentPkey"] = "task_document_pkey";
})(TaskDocumentConstraint || (TaskDocumentConstraint = {}));
/** select columns of table "pl.task_document" */
export var TaskDocumentSelectColumn;
(function (TaskDocumentSelectColumn) {
    /** column name */
    TaskDocumentSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    TaskDocumentSelectColumn["DocumentDeletedAt"] = "document_deleted_at";
    /** column name */
    TaskDocumentSelectColumn["DocumentDeletedByUserId"] = "document_deleted_by_user_id";
    /** column name */
    TaskDocumentSelectColumn["DocumentId"] = "document_id";
    /** column name */
    TaskDocumentSelectColumn["Id"] = "id";
    /** column name */
    TaskDocumentSelectColumn["TaskId"] = "task_id";
})(TaskDocumentSelectColumn || (TaskDocumentSelectColumn = {}));
/** update columns of table "pl.task_document" */
export var TaskDocumentUpdateColumn;
(function (TaskDocumentUpdateColumn) {
    /** column name */
    TaskDocumentUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    TaskDocumentUpdateColumn["DocumentDeletedAt"] = "document_deleted_at";
    /** column name */
    TaskDocumentUpdateColumn["DocumentDeletedByUserId"] = "document_deleted_by_user_id";
    /** column name */
    TaskDocumentUpdateColumn["DocumentId"] = "document_id";
    /** column name */
    TaskDocumentUpdateColumn["Id"] = "id";
    /** column name */
    TaskDocumentUpdateColumn["TaskId"] = "task_id";
})(TaskDocumentUpdateColumn || (TaskDocumentUpdateColumn = {}));
/** select columns of table "pl.task_only_creator" */
export var TaskOnlyCreatorSelectColumn;
(function (TaskOnlyCreatorSelectColumn) {
    /** column name */
    TaskOnlyCreatorSelectColumn["CreatorId"] = "creator_id";
    /** column name */
    TaskOnlyCreatorSelectColumn["IsPublic"] = "is_public";
    /** column name */
    TaskOnlyCreatorSelectColumn["TaskId"] = "task_id";
})(TaskOnlyCreatorSelectColumn || (TaskOnlyCreatorSelectColumn = {}));
/** select columns of table "pl.task" */
export var TaskSelectColumn;
(function (TaskSelectColumn) {
    /** column name */
    TaskSelectColumn["AssigneeId"] = "assignee_id";
    /** column name */
    TaskSelectColumn["CompanyId"] = "company_id";
    /** column name */
    TaskSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    TaskSelectColumn["CreatorId"] = "creator_id";
    /** column name */
    TaskSelectColumn["DeletedAt"] = "deleted_at";
    /** column name */
    TaskSelectColumn["Description"] = "description";
    /** column name */
    TaskSelectColumn["DueDate"] = "due_date";
    /** column name */
    TaskSelectColumn["Id"] = "id";
    /** column name */
    TaskSelectColumn["IsCompleted"] = "is_completed";
    /** column name */
    TaskSelectColumn["IsPublic"] = "is_public";
    /** column name */
    TaskSelectColumn["Status"] = "status";
    /** column name */
    TaskSelectColumn["Title"] = "title";
    /** column name */
    TaskSelectColumn["UpdatedAt"] = "updated_at";
})(TaskSelectColumn || (TaskSelectColumn = {}));
/** unique or primary key constraints on table "pl.task_status_enum" */
export var TaskStatusEnumConstraint;
(function (TaskStatusEnumConstraint) {
    /** unique or primary key constraint on columns "name" */
    TaskStatusEnumConstraint["TaskStatusEnumPkey"] = "task_status_enum_pkey";
})(TaskStatusEnumConstraint || (TaskStatusEnumConstraint = {}));
export var TaskStatusEnumEnum;
(function (TaskStatusEnumEnum) {
    /** Completed */
    TaskStatusEnumEnum["Completed"] = "completed";
    /** In Progress */
    TaskStatusEnumEnum["InProgress"] = "in_progress";
    /** Todo */
    TaskStatusEnumEnum["Todo"] = "todo";
})(TaskStatusEnumEnum || (TaskStatusEnumEnum = {}));
/** select columns of table "pl.task_status_enum" */
export var TaskStatusEnumSelectColumn;
(function (TaskStatusEnumSelectColumn) {
    /** column name */
    TaskStatusEnumSelectColumn["Description"] = "description";
    /** column name */
    TaskStatusEnumSelectColumn["Name"] = "name";
})(TaskStatusEnumSelectColumn || (TaskStatusEnumSelectColumn = {}));
/** update columns of table "pl.task_status_enum" */
export var TaskStatusEnumUpdateColumn;
(function (TaskStatusEnumUpdateColumn) {
    /** column name */
    TaskStatusEnumUpdateColumn["Description"] = "description";
    /** column name */
    TaskStatusEnumUpdateColumn["Name"] = "name";
})(TaskStatusEnumUpdateColumn || (TaskStatusEnumUpdateColumn = {}));
/** unique or primary key constraints on table "pl.task_template" */
export var TaskTemplateConstraint;
(function (TaskTemplateConstraint) {
    /** unique or primary key constraint on columns "id" */
    TaskTemplateConstraint["TaskTemplatePkey"] = "task_template_pkey";
})(TaskTemplateConstraint || (TaskTemplateConstraint = {}));
/** select columns of table "pl.task_template" */
export var TaskTemplateSelectColumn;
(function (TaskTemplateSelectColumn) {
    /** column name */
    TaskTemplateSelectColumn["Id"] = "id";
    /** column name */
    TaskTemplateSelectColumn["TaskId"] = "task_id";
    /** column name */
    TaskTemplateSelectColumn["TemplateId"] = "template_id";
})(TaskTemplateSelectColumn || (TaskTemplateSelectColumn = {}));
/** update columns of table "pl.task_template" */
export var TaskTemplateUpdateColumn;
(function (TaskTemplateUpdateColumn) {
    /** column name */
    TaskTemplateUpdateColumn["Id"] = "id";
    /** column name */
    TaskTemplateUpdateColumn["TaskId"] = "task_id";
    /** column name */
    TaskTemplateUpdateColumn["TemplateId"] = "template_id";
})(TaskTemplateUpdateColumn || (TaskTemplateUpdateColumn = {}));
/** update columns of table "pl.task" */
export var TaskUpdateColumn;
(function (TaskUpdateColumn) {
    /** column name */
    TaskUpdateColumn["AssigneeId"] = "assignee_id";
    /** column name */
    TaskUpdateColumn["CompanyId"] = "company_id";
    /** column name */
    TaskUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    TaskUpdateColumn["CreatorId"] = "creator_id";
    /** column name */
    TaskUpdateColumn["DeletedAt"] = "deleted_at";
    /** column name */
    TaskUpdateColumn["Description"] = "description";
    /** column name */
    TaskUpdateColumn["DueDate"] = "due_date";
    /** column name */
    TaskUpdateColumn["Id"] = "id";
    /** column name */
    TaskUpdateColumn["IsCompleted"] = "is_completed";
    /** column name */
    TaskUpdateColumn["IsPublic"] = "is_public";
    /** column name */
    TaskUpdateColumn["Status"] = "status";
    /** column name */
    TaskUpdateColumn["Title"] = "title";
    /** column name */
    TaskUpdateColumn["UpdatedAt"] = "updated_at";
})(TaskUpdateColumn || (TaskUpdateColumn = {}));
export var TeamMemberRole;
(function (TeamMemberRole) {
    TeamMemberRole["Manager"] = "Manager";
    TeamMemberRole["Member"] = "Member";
})(TeamMemberRole || (TeamMemberRole = {}));
export var TextExtractionStatus;
(function (TextExtractionStatus) {
    TextExtractionStatus["Failed"] = "FAILED";
    TextExtractionStatus["Pending"] = "PENDING";
    TextExtractionStatus["Queued"] = "QUEUED";
    TextExtractionStatus["Succeeded"] = "SUCCEEDED";
})(TextExtractionStatus || (TextExtractionStatus = {}));
export var UpdateDocumentEsigningSettingsRejectionReason;
(function (UpdateDocumentEsigningSettingsRejectionReason) {
    UpdateDocumentEsigningSettingsRejectionReason["NotAuthorized"] = "NOT_AUTHORIZED";
})(UpdateDocumentEsigningSettingsRejectionReason || (UpdateDocumentEsigningSettingsRejectionReason = {}));
export var UpdateEsigningRecipientRejectionReason;
(function (UpdateEsigningRecipientRejectionReason) {
    UpdateEsigningRecipientRejectionReason["ActiveSignRequest"] = "ACTIVE_SIGN_REQUEST";
    UpdateEsigningRecipientRejectionReason["AlreadySigned"] = "ALREADY_SIGNED";
    UpdateEsigningRecipientRejectionReason["CannotConvertRecipientWithActiveSignRequest"] = "CANNOT_CONVERT_RECIPIENT_WITH_ACTIVE_SIGN_REQUEST";
    UpdateEsigningRecipientRejectionReason["CannotNormalizeNames"] = "CANNOT_NORMALIZE_NAMES";
    UpdateEsigningRecipientRejectionReason["MissingMobileNumber"] = "MISSING_MOBILE_NUMBER";
    UpdateEsigningRecipientRejectionReason["NotAuthorized"] = "NOT_AUTHORIZED";
    UpdateEsigningRecipientRejectionReason["NotConnectedToEsigningProvider"] = "NOT_CONNECTED_TO_ESIGNING_PROVIDER";
    UpdateEsigningRecipientRejectionReason["NotFound"] = "NOT_FOUND";
    UpdateEsigningRecipientRejectionReason["NotSupported"] = "NOT_SUPPORTED";
    UpdateEsigningRecipientRejectionReason["PendingSignRequest"] = "PENDING_SIGN_REQUEST";
    UpdateEsigningRecipientRejectionReason["ProviderRequestFailed"] = "PROVIDER_REQUEST_FAILED";
    UpdateEsigningRecipientRejectionReason["UnsupportedAuthenticationMode"] = "UNSUPPORTED_AUTHENTICATION_MODE";
})(UpdateEsigningRecipientRejectionReason || (UpdateEsigningRecipientRejectionReason = {}));
export var UpdateEsigningRecipientValueRejectionReason;
(function (UpdateEsigningRecipientValueRejectionReason) {
    UpdateEsigningRecipientValueRejectionReason["CannotNormalizeNames"] = "CANNOT_NORMALIZE_NAMES";
    UpdateEsigningRecipientValueRejectionReason["MissingMobileNumber"] = "MISSING_MOBILE_NUMBER";
    UpdateEsigningRecipientValueRejectionReason["NotAuthorized"] = "NOT_AUTHORIZED";
    UpdateEsigningRecipientValueRejectionReason["NotFound"] = "NOT_FOUND";
})(UpdateEsigningRecipientValueRejectionReason || (UpdateEsigningRecipientValueRejectionReason = {}));
export var UploadIntent;
(function (UploadIntent) {
    UploadIntent["FileSystemDocument"] = "FILE_SYSTEM_DOCUMENT";
    UploadIntent["InboxFile"] = "INBOX_FILE";
    UploadIntent["SignedDocument"] = "SIGNED_DOCUMENT";
})(UploadIntent || (UploadIntent = {}));
/** select columns of table "pl.user_companies_view" */
export var UserCompaniesViewSelectColumn;
(function (UserCompaniesViewSelectColumn) {
    /** column name */
    UserCompaniesViewSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    UserCompaniesViewSelectColumn["Id"] = "id";
    /** column name */
    UserCompaniesViewSelectColumn["Name"] = "name";
    /** column name */
    UserCompaniesViewSelectColumn["OrganizationNumber"] = "organization_number";
    /** column name */
    UserCompaniesViewSelectColumn["StripeCustomerId"] = "stripe_customer_id";
    /** column name */
    UserCompaniesViewSelectColumn["UpdatedAt"] = "updated_at";
    /** column name */
    UserCompaniesViewSelectColumn["UserId"] = "user_id";
})(UserCompaniesViewSelectColumn || (UserCompaniesViewSelectColumn = {}));
/** unique or primary key constraints on table "pl.user" */
export var UserConstraint;
(function (UserConstraint) {
    /** unique or primary key constraint on columns "id" */
    UserConstraint["UserPkey"] = "user_pkey";
})(UserConstraint || (UserConstraint = {}));
/** unique or primary key constraints on table "pl.user_invite" */
export var UserInviteConstraint;
(function (UserInviteConstraint) {
    /** unique or primary key constraint on columns "id" */
    UserInviteConstraint["UserInvitePkey"] = "user_invite_pkey";
})(UserInviteConstraint || (UserInviteConstraint = {}));
/** select columns of table "pl.user_invite" */
export var UserInviteSelectColumn;
(function (UserInviteSelectColumn) {
    /** column name */
    UserInviteSelectColumn["AcceptedByUserId"] = "accepted_by_user_id";
    /** column name */
    UserInviteSelectColumn["AllowedComposers"] = "allowed_composers";
    /** column name */
    UserInviteSelectColumn["CanManageMember"] = "can_manage_member";
    /** column name */
    UserInviteSelectColumn["CompanyId"] = "company_id";
    /** column name */
    UserInviteSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    UserInviteSelectColumn["DeletedAt"] = "deleted_at";
    /** column name */
    UserInviteSelectColumn["Email"] = "email";
    /** column name */
    UserInviteSelectColumn["Id"] = "id";
    /** column name */
    UserInviteSelectColumn["InvitedByUserId"] = "invited_by_user_id";
    /** column name */
    UserInviteSelectColumn["Key"] = "key";
    /** column name */
    UserInviteSelectColumn["Role"] = "role";
    /** column name */
    UserInviteSelectColumn["UpdatedAt"] = "updated_at";
})(UserInviteSelectColumn || (UserInviteSelectColumn = {}));
/** select "pl_user_invite_aggregate_bool_exp_bool_and_arguments_columns" columns of table "pl.user_invite" */
export var UserInviteSelectColumnPlUserInviteAggregateBoolExpBoolAndArgumentsColumns;
(function (UserInviteSelectColumnPlUserInviteAggregateBoolExpBoolAndArgumentsColumns) {
    /** column name */
    UserInviteSelectColumnPlUserInviteAggregateBoolExpBoolAndArgumentsColumns["CanManageMember"] = "can_manage_member";
})(UserInviteSelectColumnPlUserInviteAggregateBoolExpBoolAndArgumentsColumns || (UserInviteSelectColumnPlUserInviteAggregateBoolExpBoolAndArgumentsColumns = {}));
/** select "pl_user_invite_aggregate_bool_exp_bool_or_arguments_columns" columns of table "pl.user_invite" */
export var UserInviteSelectColumnPlUserInviteAggregateBoolExpBoolOrArgumentsColumns;
(function (UserInviteSelectColumnPlUserInviteAggregateBoolExpBoolOrArgumentsColumns) {
    /** column name */
    UserInviteSelectColumnPlUserInviteAggregateBoolExpBoolOrArgumentsColumns["CanManageMember"] = "can_manage_member";
})(UserInviteSelectColumnPlUserInviteAggregateBoolExpBoolOrArgumentsColumns || (UserInviteSelectColumnPlUserInviteAggregateBoolExpBoolOrArgumentsColumns = {}));
/** update columns of table "pl.user_invite" */
export var UserInviteUpdateColumn;
(function (UserInviteUpdateColumn) {
    /** column name */
    UserInviteUpdateColumn["AcceptedByUserId"] = "accepted_by_user_id";
    /** column name */
    UserInviteUpdateColumn["AllowedComposers"] = "allowed_composers";
    /** column name */
    UserInviteUpdateColumn["CanManageMember"] = "can_manage_member";
    /** column name */
    UserInviteUpdateColumn["CompanyId"] = "company_id";
    /** column name */
    UserInviteUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    UserInviteUpdateColumn["DeletedAt"] = "deleted_at";
    /** column name */
    UserInviteUpdateColumn["Email"] = "email";
    /** column name */
    UserInviteUpdateColumn["Id"] = "id";
    /** column name */
    UserInviteUpdateColumn["InvitedByUserId"] = "invited_by_user_id";
    /** column name */
    UserInviteUpdateColumn["Key"] = "key";
    /** column name */
    UserInviteUpdateColumn["Role"] = "role";
    /** column name */
    UserInviteUpdateColumn["UpdatedAt"] = "updated_at";
})(UserInviteUpdateColumn || (UserInviteUpdateColumn = {}));
export var UserReferrer2;
(function (UserReferrer2) {
    UserReferrer2["Other"] = "_other";
    UserReferrer2["ArticleBlog"] = "article_blog";
    UserReferrer2["EventSeminar"] = "event_seminar";
    UserReferrer2["Recommended"] = "recommended";
    UserReferrer2["SearchEngine"] = "search_engine";
    UserReferrer2["SocialMedia"] = "social_media";
})(UserReferrer2 || (UserReferrer2 = {}));
/** unique or primary key constraints on table "pl.user_referrer_enum" */
export var UserReferrerEnumConstraint;
(function (UserReferrerEnumConstraint) {
    /** unique or primary key constraint on columns "name" */
    UserReferrerEnumConstraint["UserReferrerEnumPkey"] = "user_referrer_enum_pkey";
})(UserReferrerEnumConstraint || (UserReferrerEnumConstraint = {}));
export var UserReferrerEnumEnum;
(function (UserReferrerEnumEnum) {
    /** Other (free choice) */
    UserReferrerEnumEnum["Other"] = "_other";
    /** Article or Blog */
    UserReferrerEnumEnum["ArticleBlog"] = "article_blog";
    /** Event or Seminar */
    UserReferrerEnumEnum["EventSeminar"] = "event_seminar";
    /** Recommended by friend or colleague */
    UserReferrerEnumEnum["Recommended"] = "recommended";
    /** Search Engine (Google, Bing, etc). */
    UserReferrerEnumEnum["SearchEngine"] = "search_engine";
    /** Social Media (LinkedIn, Instagram etc.) */
    UserReferrerEnumEnum["SocialMedia"] = "social_media";
})(UserReferrerEnumEnum || (UserReferrerEnumEnum = {}));
/** select columns of table "pl.user_referrer_enum" */
export var UserReferrerEnumSelectColumn;
(function (UserReferrerEnumSelectColumn) {
    /** column name */
    UserReferrerEnumSelectColumn["Description"] = "description";
    /** column name */
    UserReferrerEnumSelectColumn["Name"] = "name";
})(UserReferrerEnumSelectColumn || (UserReferrerEnumSelectColumn = {}));
/** update columns of table "pl.user_referrer_enum" */
export var UserReferrerEnumUpdateColumn;
(function (UserReferrerEnumUpdateColumn) {
    /** column name */
    UserReferrerEnumUpdateColumn["Description"] = "description";
    /** column name */
    UserReferrerEnumUpdateColumn["Name"] = "name";
})(UserReferrerEnumUpdateColumn || (UserReferrerEnumUpdateColumn = {}));
/** select columns of table "pl.user" */
export var UserSelectColumn;
(function (UserSelectColumn) {
    /** column name */
    UserSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    UserSelectColumn["DefaultCompanyId"] = "default_company_id";
    /** column name */
    UserSelectColumn["Email"] = "email";
    /** column name */
    UserSelectColumn["Id"] = "id";
    /** column name */
    UserSelectColumn["IsExternal"] = "is_external";
    /** column name */
    UserSelectColumn["Name"] = "name";
    /** column name */
    UserSelectColumn["PhoneNumber"] = "phone_number";
    /** column name */
    UserSelectColumn["PreferredLocale"] = "preferred_locale";
    /** column name */
    UserSelectColumn["Referrer"] = "referrer";
    /** column name */
    UserSelectColumn["ReferrerOther"] = "referrer_other";
    /** column name */
    UserSelectColumn["UpdatedAt"] = "updated_at";
})(UserSelectColumn || (UserSelectColumn = {}));
/** update columns of table "pl.user" */
export var UserUpdateColumn;
(function (UserUpdateColumn) {
    /** column name */
    UserUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    UserUpdateColumn["DefaultCompanyId"] = "default_company_id";
    /** column name */
    UserUpdateColumn["Email"] = "email";
    /** column name */
    UserUpdateColumn["Id"] = "id";
    /** column name */
    UserUpdateColumn["IsExternal"] = "is_external";
    /** column name */
    UserUpdateColumn["Name"] = "name";
    /** column name */
    UserUpdateColumn["PhoneNumber"] = "phone_number";
    /** column name */
    UserUpdateColumn["PreferredLocale"] = "preferred_locale";
    /** column name */
    UserUpdateColumn["Referrer"] = "referrer";
    /** column name */
    UserUpdateColumn["ReferrerOther"] = "referrer_other";
    /** column name */
    UserUpdateColumn["UpdatedAt"] = "updated_at";
})(UserUpdateColumn || (UserUpdateColumn = {}));
export var WebApiClientUserRole;
(function (WebApiClientUserRole) {
    WebApiClientUserRole["Member"] = "MEMBER";
    WebApiClientUserRole["Owner"] = "OWNER";
})(WebApiClientUserRole || (WebApiClientUserRole = {}));
export var WorkflowSortField;
(function (WorkflowSortField) {
    WorkflowSortField["CreatedAt"] = "createdAt";
    WorkflowSortField["Name"] = "name";
    WorkflowSortField["UpdatedAt"] = "updatedAt";
})(WorkflowSortField || (WorkflowSortField = {}));
export var WorkflowType;
(function (WorkflowType) {
    WorkflowType["ApprovalRequirementCheck"] = "APPROVAL_REQUIREMENT_CHECK";
    WorkflowType["SuggestSignatories"] = "SUGGEST_SIGNATORIES";
})(WorkflowType || (WorkflowType = {}));
export var WorkflowVersionSortField;
(function (WorkflowVersionSortField) {
    WorkflowVersionSortField["CreatedAt"] = "createdAt";
    WorkflowVersionSortField["VersionNumber"] = "versionNumber";
})(WorkflowVersionSortField || (WorkflowVersionSortField = {}));
export var Link__Purpose;
(function (Link__Purpose) {
    /** `EXECUTION` features provide metadata necessary for operation execution. */
    Link__Purpose["Execution"] = "EXECUTION";
    /** `SECURITY` features provide metadata necessary to securely resolve fields. */
    Link__Purpose["Security"] = "SECURITY";
})(Link__Purpose || (Link__Purpose = {}));
